var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTargetUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 397.875,
    height: 360.972,
    viewBox: "0 0 397.875 360.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Target_Users",
    "data-name": "Target Users",
    transform: "translate(-14.694 -40.228)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(15.644 43.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6294",
    "data-name": "Group 6294",
    transform: "translate(126.474 9.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6293",
    "data-name": "Group 6293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M236.6,73.008c.544-3.955-5.038-7.21-9.233-7.548-2-.161-4.079.145-5.973-.516-4.106-1.432-5.747-6.736-9.753-8.426-3-1.263-6.443-.139-9.347,1.323s-5.774,3.3-9.018,3.508c-2.822.181-5.886-.865-8.356.513-1.84,1.027-2.8,3.147-4.5,4.4a10.733,10.733,0,0,1-5.881,1.595,16.569,16.569,0,0,0-6.064.99c-1.874.859-3.424,2.84-3.036,4.864Z",
    transform: "translate(-165.38 -55.971)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6296",
    "data-name": "Group 6296",
    transform: "translate(291.591 82.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6295",
    "data-name": "Group 6295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M431.979,158.713c.545-3.956-5.038-7.21-9.233-7.548-2-.161-4.078.145-5.973-.516-4.106-1.431-5.747-6.736-9.754-8.426-2.995-1.263-6.443-.139-9.347,1.323s-5.774,3.3-9.018,3.509c-2.822.181-5.886-.866-8.356.512-1.84,1.028-2.8,3.147-4.5,4.4a10.729,10.729,0,0,1-5.882,1.595,16.57,16.57,0,0,0-6.064.991c-1.874.858-3.424,2.84-3.036,4.864Z",
    transform: "translate(-360.759 -141.676)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6320",
    "data-name": "Group 6320",
    transform: "translate(298.387 167.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6305",
    "data-name": "Group 6305",
    transform: "translate(0 5.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M378.595,384.66H368.8V253.96a4.9,4.9,0,0,1,4.9-4.9h0a4.9,4.9,0,0,1,4.9,4.9Z",
    transform: "translate(-368.8 -249.063)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6306",
    "data-name": "Group 6306",
    transform: "translate(26.714 5.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M410.2,384.66H400.41V253.96a4.9,4.9,0,0,1,4.9-4.9h0a4.9,4.9,0,0,1,4.9,4.9Z",
    transform: "translate(-400.41 -249.063)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6312",
    "data-name": "Group 6312",
    transform: "translate(4.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6307",
    "data-name": "Group 6307",
    transform: "translate(0 2.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M399.492,248.984H376.018a1.764,1.764,0,0,1-1.764-1.764h0a1.763,1.763,0,0,1,1.764-1.764h23.475a1.763,1.763,0,0,1,1.764,1.764h0A1.764,1.764,0,0,1,399.492,248.984Z",
    transform: "translate(-374.254 -245.456)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6308",
    "data-name": "Group 6308",
    transform: "translate(4.71 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M382.221,250.728h0a2.394,2.394,0,0,1-2.394-2.394v-3.929a2.394,2.394,0,0,1,2.394-2.394h0a2.394,2.394,0,0,1,2.394,2.394v3.929A2.394,2.394,0,0,1,382.221,250.728Z",
    transform: "translate(-379.827 -242.011)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6309",
    "data-name": "Group 6309",
    transform: "translate(9.105 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M387.422,250.728h0a2.394,2.394,0,0,1-2.394-2.394v-3.929a2.394,2.394,0,0,1,2.394-2.394h0a2.394,2.394,0,0,1,2.394,2.394v3.929A2.394,2.394,0,0,1,387.422,250.728Z",
    transform: "translate(-385.028 -242.011)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6310",
    "data-name": "Group 6310",
    transform: "translate(13.501 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M392.623,250.728h0a2.394,2.394,0,0,1-2.394-2.394v-3.929a2.394,2.394,0,0,1,2.394-2.394h0a2.394,2.394,0,0,1,2.394,2.394v3.929A2.394,2.394,0,0,1,392.623,250.728Z",
    transform: "translate(-390.229 -242.011)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6311",
    "data-name": "Group 6311",
    transform: "translate(17.896)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 4.788,
    height: 8.718,
    rx: 2.394,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6313",
    "data-name": "Group 6313",
    transform: "translate(52.157 5.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M440.311,384.66h-9.795V253.96a4.9,4.9,0,0,1,4.9-4.9h0a4.9,4.9,0,0,1,4.9,4.9Z",
    transform: "translate(-430.516 -249.063)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6319",
    "data-name": "Group 6319",
    transform: "translate(30.052 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6314",
    "data-name": "Group 6314",
    transform: "translate(0 2.911)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M429.6,248.984H406.124a1.764,1.764,0,0,1-1.764-1.764h0a1.763,1.763,0,0,1,1.764-1.764H429.6a1.763,1.763,0,0,1,1.764,1.764h0A1.764,1.764,0,0,1,429.6,248.984Z",
    transform: "translate(-404.36 -245.456)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6315",
    "data-name": "Group 6315",
    transform: "translate(4.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M412.327,250.728h0a2.394,2.394,0,0,1-2.394-2.394v-3.929a2.394,2.394,0,0,1,2.394-2.394h0a2.394,2.394,0,0,1,2.394,2.394v3.929A2.394,2.394,0,0,1,412.327,250.728Z",
    transform: "translate(-409.933 -242.011)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6316",
    "data-name": "Group 6316",
    transform: "translate(9.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M417.528,250.728h0a2.394,2.394,0,0,1-2.394-2.394v-3.929a2.394,2.394,0,0,1,2.394-2.394h0a2.394,2.394,0,0,1,2.394,2.394v3.929A2.394,2.394,0,0,1,417.528,250.728Z",
    transform: "translate(-415.134 -242.011)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6317",
    "data-name": "Group 6317",
    transform: "translate(13.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M422.729,250.728h0a2.394,2.394,0,0,1-2.394-2.394v-3.929a2.394,2.394,0,0,1,2.394-2.394h0a2.4,2.4,0,0,1,2.4,2.394v3.929A2.4,2.4,0,0,1,422.729,250.728Z",
    transform: "translate(-420.335 -242.011)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6318",
    "data-name": "Group 6318",
    transform: "translate(17.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M427.931,250.728h0a2.394,2.394,0,0,1-2.394-2.394v-3.929a2.394,2.394,0,0,1,2.394-2.394h0a2.394,2.394,0,0,1,2.394,2.394v3.929A2.394,2.394,0,0,1,427.931,250.728Z",
    transform: "translate(-425.537 -242.011)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6322",
    "data-name": "Group 6322",
    transform: "translate(33.952 73.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6321",
    "data-name": "Group 6321",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M127.121,148.4c.545-3.956-5.038-7.21-9.233-7.548-2-.161-4.079.145-5.973-.516-4.106-1.431-5.746-6.736-9.753-8.426-3-1.263-6.444-.139-9.348,1.323s-5.774,3.3-9.018,3.508c-2.822.181-5.886-.866-8.355.512-1.84,1.028-2.8,3.148-4.5,4.4a10.729,10.729,0,0,1-5.882,1.595,16.587,16.587,0,0,0-6.064.991c-1.874.858-3.424,2.84-3.036,4.864Z",
    transform: "translate(-55.901 -131.367)",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(15.194 352.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6326",
    "data-name": "Group 6326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6325",
    "data-name": "Group 6325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M412.069,409.543c0,.122-88.851.221-198.428.221-109.615,0-198.447-.1-198.447-.221s88.832-.22,198.447-.22C323.218,409.323,412.069,409.421,412.069,409.543Z",
    transform: "translate(-15.194 -409.323)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Plants",
    transform: "translate(44.142 318.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6333",
    "data-name": "Group 6333",
    transform: "translate(49.949 19.691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6328",
    "data-name": "Group 6328",
    transform: "translate(0 0.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6327",
    "data-name": "Group 6327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M108.554,393.823a9.439,9.439,0,0,1,1.8,1.569,28.049,28.049,0,0,1,6.188,9.666,9.488,9.488,0,0,1,.67,2.293,19.883,19.883,0,0,1-.958-2.175,35.4,35.4,0,0,0-6.127-9.571A20.169,20.169,0,0,1,108.554,393.823Z",
    transform: "translate(-108.551 -393.821)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6330",
    "data-name": "Group 6330",
    transform: "translate(10.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6329",
    "data-name": "Group 6329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M121.267,392.687a11.5,11.5,0,0,1,.143,2.1c.05,1.293.138,3.075.313,5.039s.407,3.734.587,5.014a11.548,11.548,0,0,1,.232,2.088,8.775,8.775,0,0,1-.539-2.036,48.1,48.1,0,0,1-.9-10.1A8.874,8.874,0,0,1,121.267,392.687Z",
    transform: "translate(-121.089 -392.687)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6332",
    "data-name": "Group 6332",
    transform: "translate(15.335 2.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6331",
    "data-name": "Group 6331"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M133.479,395.384a31.078,31.078,0,0,0-6.769,12.5,7.449,7.449,0,0,1,.37-2.09,22.148,22.148,0,0,1,4.849-8.954A7.471,7.471,0,0,1,133.479,395.384Z",
    transform: "translate(-126.697 -395.382)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6340",
    "data-name": "Group 6340",
    transform: "translate(18.962 66.382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6335",
    "data-name": "Group 6335",
    transform: "translate(0 0.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6334",
    "data-name": "Group 6334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M71.888,449.073a9.444,9.444,0,0,1,1.8,1.569,28.035,28.035,0,0,1,6.188,9.666,9.45,9.45,0,0,1,.67,2.293,19.907,19.907,0,0,1-.958-2.175,35.346,35.346,0,0,0-6.127-9.571A19.972,19.972,0,0,1,71.888,449.073Z",
    transform: "translate(-71.885 -449.071)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6337",
    "data-name": "Group 6337",
    transform: "translate(10.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6336",
    "data-name": "Group 6336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M84.6,447.936a11.571,11.571,0,0,1,.142,2.1c.051,1.292.138,3.075.313,5.038s.407,3.734.587,5.015a11.537,11.537,0,0,1,.232,2.087,8.828,8.828,0,0,1-.539-2.035,48.1,48.1,0,0,1-.9-10.1A8.792,8.792,0,0,1,84.6,447.936Z",
    transform: "translate(-84.422 -447.936)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6339",
    "data-name": "Group 6339",
    transform: "translate(15.335 2.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6338",
    "data-name": "Group 6338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M96.812,450.634a31.047,31.047,0,0,0-6.768,12.5,7.421,7.421,0,0,1,.369-2.09,22.132,22.132,0,0,1,4.85-8.955A7.466,7.466,0,0,1,96.812,450.634Z",
    transform: "translate(-90.031 -450.632)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6347",
    "data-name": "Group 6347",
    transform: "translate(292.856 67.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6342",
    "data-name": "Group 6342",
    transform: "translate(0 0.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6341",
    "data-name": "Group 6341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M395.979,450.422a9.4,9.4,0,0,1,1.8,1.568,28.034,28.034,0,0,1,6.189,9.666,9.406,9.406,0,0,1,.669,2.293,20.021,20.021,0,0,1-.958-2.175,35.4,35.4,0,0,0-6.127-9.571A20.093,20.093,0,0,1,395.979,450.422Z",
    transform: "translate(-395.976 -450.42)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6344",
    "data-name": "Group 6344",
    transform: "translate(10.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6343",
    "data-name": "Group 6343"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M408.691,449.285a11.492,11.492,0,0,1,.143,2.1c.05,1.293.137,3.075.312,5.039s.408,3.734.588,5.015a11.63,11.63,0,0,1,.232,2.087,8.772,8.772,0,0,1-.539-2.036,48.164,48.164,0,0,1-.905-10.1A8.79,8.79,0,0,1,408.691,449.285Z",
    transform: "translate(-408.514 -449.285)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6346",
    "data-name": "Group 6346",
    transform: "translate(15.335 2.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6345",
    "data-name": "Group 6345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M420.9,451.983a31.066,31.066,0,0,0-6.768,12.495,7.456,7.456,0,0,1,.369-2.089,22.159,22.159,0,0,1,4.85-8.955A7.394,7.394,0,0,1,420.9,451.983Z",
    transform: "translate(-414.122 -451.981)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6354",
    "data-name": "Group 6354",
    transform: "translate(166.299 61.814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6349",
    "data-name": "Group 6349",
    transform: "translate(0 0.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6348",
    "data-name": "Group 6348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M246.227,443.666a9.441,9.441,0,0,1,1.8,1.569,28.049,28.049,0,0,1,6.188,9.666,9.406,9.406,0,0,1,.669,2.293,19.989,19.989,0,0,1-.958-2.176,35.4,35.4,0,0,0-6.127-9.571A19.942,19.942,0,0,1,246.227,443.666Z",
    transform: "translate(-246.224 -443.664)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6351",
    "data-name": "Group 6351",
    transform: "translate(10.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6350",
    "data-name": "Group 6350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M258.939,442.53a11.489,11.489,0,0,1,.143,2.1c.05,1.292.138,3.075.312,5.038s.408,3.734.588,5.015a11.642,11.642,0,0,1,.232,2.088,8.807,8.807,0,0,1-.539-2.036,48.1,48.1,0,0,1-.9-10.1A8.808,8.808,0,0,1,258.939,442.53Z",
    transform: "translate(-258.762 -442.53)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6353",
    "data-name": "Group 6353",
    transform: "translate(15.335 2.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6352",
    "data-name": "Group 6352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M271.152,445.227a31.061,31.061,0,0,0-6.769,12.5,7.463,7.463,0,0,1,.369-2.09,22.159,22.159,0,0,1,4.85-8.955A7.454,7.454,0,0,1,271.152,445.227Z",
    transform: "translate(-264.37 -445.225)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6376",
    "data-name": "Group 6376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6357",
    "data-name": "Group 6357",
    transform: "translate(8.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6356",
    "data-name": "Group 6356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6355",
    "data-name": "Group 6355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M63.6,369.417a6.45,6.45,0,0,1,3.342,3.785,11.386,11.386,0,0,1,.444,5.128c-.377,3.328-2.267,6.687-4.3,9.346-2.8-2.446-3.447-6.712-3.638-8.9-.3-3.453,1.249-9.878,4.156-9.363",
    transform: "translate(-59.403 -369.387)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6360",
    "data-name": "Group 6360",
    transform: "translate(15.22 16.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6359",
    "data-name": "Group 6359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6358",
    "data-name": "Group 6358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M67.583,396.255a5.5,5.5,0,0,1,1.777-5.23,7.309,7.309,0,0,1,5.389-1.683,3.077,3.077,0,0,1,2.365,1.062,2.35,2.35,0,0,1,.036,2.384,4.773,4.773,0,0,1-1.765,1.739c-2.428,1.523-5.058,2.552-7.8,1.727",
    transform: "translate(-67.456 -389.318)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6364",
    "data-name": "Group 6364",
    transform: "translate(11.749 20.129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6363",
    "data-name": "Group 6363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6362",
    "data-name": "Group 6362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6361",
    "data-name": "Group 6361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M63.353,407.061a3.819,3.819,0,0,1,.1-.683c.088-.481.2-1.1.339-1.848a19.292,19.292,0,0,1,1.907-5.9,11.813,11.813,0,0,1,4.237-4.5,8.027,8.027,0,0,1,1.727-.764c.211-.071.384-.1.5-.127a.533.533,0,0,1,.178-.025,12.521,12.521,0,0,0-2.315,1.062,12.211,12.211,0,0,0-4.113,4.473,20.775,20.775,0,0,0-1.951,5.82c-.17.774-.308,1.4-.415,1.833A3.716,3.716,0,0,1,63.353,407.061Z",
    transform: "translate(-63.349 -393.206)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6368",
    "data-name": "Group 6368",
    transform: "translate(11.718 5.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6367",
    "data-name": "Group 6367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6366",
    "data-name": "Group 6366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6365",
    "data-name": "Group 6365"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M63.453,375.335a1.482,1.482,0,0,1,.034.3c.014.221.03.505.051.858.04.745.084,1.824.127,3.157.086,2.666.154,6.352.137,10.423s-.117,7.757-.227,10.423c-.054,1.333-.107,2.41-.154,3.155-.024.352-.043.636-.058.858a1.363,1.363,0,0,1-.037.3,1.49,1.49,0,0,1-.012-.3l.013-.859c.019-.776.045-1.847.077-3.157.066-2.665.138-6.349.156-10.419s-.024-7.751-.066-10.417c-.02-1.311-.037-2.382-.05-3.158,0-.352,0-.637-.005-.859A1.372,1.372,0,0,1,63.453,375.335Z",
    transform: "translate(-63.313 -375.335)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6371",
    "data-name": "Group 6371",
    transform: "translate(0 15.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6370",
    "data-name": "Group 6370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6369",
    "data-name": "Group 6369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M59.945,398.112a12.869,12.869,0,0,0-7.027-9.428c-.936-.448-2.159-.741-2.929-.045s-.6,1.95-.221,2.919a11,11,0,0,0,10.112,6.827",
    transform: "translate(-49.448 -388.223)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6375",
    "data-name": "Group 6375",
    transform: "translate(3.924 19.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6374",
    "data-name": "Group 6374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6373",
    "data-name": "Group 6373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6372",
    "data-name": "Group 6372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M54.091,392.5a3.3,3.3,0,0,1,.594.259,6.276,6.276,0,0,1,.673.358c.251.157.555.31.855.537a11.39,11.39,0,0,1,.979.736,12.756,12.756,0,0,1,1.041.947,14.345,14.345,0,0,1,1.979,2.542,14.057,14.057,0,0,1,1.3,2.948,12.153,12.153,0,0,1,.33,1.369,10.422,10.422,0,0,1,.168,1.214,9.59,9.59,0,0,1,.046,1.009,5.813,5.813,0,0,1-.023.761,3.3,3.3,0,0,1-.072.645c-.055,0,.041-.926-.123-2.4a11.206,11.206,0,0,0-.2-1.192A12.824,12.824,0,0,0,61.3,400.9a14.565,14.565,0,0,0-1.3-2.889,14.877,14.877,0,0,0-1.93-2.511,13.426,13.426,0,0,0-1.012-.949c-.321-.293-.652-.527-.947-.75C54.91,392.935,54.066,392.55,54.091,392.5Z",
    transform: "translate(-54.09 -392.501)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Sun",
    transform: "translate(326.177 59.331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6415",
    "data-name": "Group 6415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6378",
    "data-name": "Group 6378",
    transform: "translate(9.77 9.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6377",
    "data-name": "Group 6377",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 9.688,
    cy: 9.688,
    r: 9.688,
    transform: "translate(0 18.862) rotate(-76.784)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6381",
    "data-name": "Group 6381",
    transform: "translate(19.934 35.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6380",
    "data-name": "Group 6380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6379",
    "data-name": "Group 6379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M406.861,112.465a39.067,39.067,0,0,1-.1-4,39.053,39.053,0,0,1,.1-4,39.514,39.514,0,0,1,.1,4A39.528,39.528,0,0,1,406.861,112.465Z",
    transform: "translate(-406.759 -104.474)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6384",
    "data-name": "Group 6384",
    transform: "translate(10.205 32.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6383",
    "data-name": "Group 6383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6382",
    "data-name": "Group 6382"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M399.5,101.808c.049.029-.863,1.7-2.035,3.728s-2.163,3.654-2.212,3.626.862-1.7,2.035-3.728S399.446,101.78,399.5,101.808Z",
    transform: "translate(-395.247 -101.808)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6387",
    "data-name": "Group 6387",
    transform: "translate(4.071 29.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6386",
    "data-name": "Group 6386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6385",
    "data-name": "Group 6385"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M392.641,97.587a21.658,21.658,0,0,1-2.262,1.929,21.55,21.55,0,0,1-2.389,1.769,43.347,43.347,0,0,1,4.651-3.7Z",
    transform: "translate(-387.989 -97.585)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6390",
    "data-name": "Group 6390",
    transform: "translate(27.9 32.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6389",
    "data-name": "Group 6389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6388",
    "data-name": "Group 6388"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M417.985,108.048a5.751,5.751,0,0,1-.255-.983c-.139-.61-.337-1.451-.584-2.371s-.5-1.748-.685-2.345a5.7,5.7,0,0,1-.272-.978,4.457,4.457,0,0,1,.409.931c.221.588.5,1.412.745,2.338s.425,1.777.528,2.4A4.523,4.523,0,0,1,417.985,108.048Z",
    transform: "translate(-416.185 -101.371)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6393",
    "data-name": "Group 6393",
    transform: "translate(33.932 27.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6392",
    "data-name": "Group 6392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6391",
    "data-name": "Group 6391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M428.917,100.126a33.9,33.9,0,0,1-2.863-2.367,33.737,33.737,0,0,1-2.73-2.522,67.612,67.612,0,0,1,5.593,4.889Z",
    transform: "translate(-423.323 -95.236)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6396",
    "data-name": "Group 6396",
    transform: "translate(35.304 21.732)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6395",
    "data-name": "Group 6395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6394",
    "data-name": "Group 6394"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M432.931,89.508a7.886,7.886,0,0,1-1.168-.167c-.718-.12-1.711-.274-2.812-.4s-2.1-.2-2.829-.247a8.154,8.154,0,0,1-1.176-.1,5.794,5.794,0,0,1,1.181-.044c.73.009,1.739.063,2.847.188s2.1.305,2.816.461A5.945,5.945,0,0,1,432.931,89.508Z",
    transform: "translate(-424.946 -88.547)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6399",
    "data-name": "Group 6399",
    transform: "translate(33.885 13.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6398",
    "data-name": "Group 6398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6397",
    "data-name": "Group 6397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M432.683,78.534c.014.055-2.083.613-4.684,1.246s-4.719,1.1-4.733,1.048,2.084-.612,4.684-1.246S432.671,78.479,432.683,78.534Z",
    transform: "translate(-423.267 -78.53)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6402",
    "data-name": "Group 6402",
    transform: "translate(27.701 2.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6401",
    "data-name": "Group 6401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6400",
    "data-name": "Group 6400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M420.6,65.545c.047.031-.956,1.632-2.24,3.575s-2.364,3.494-2.411,3.462.956-1.631,2.241-3.575S420.557,65.514,420.6,65.545Z",
    transform: "translate(-415.95 -65.544)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6405",
    "data-name": "Group 6405",
    transform: "translate(21.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6404",
    "data-name": "Group 6404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6403",
    "data-name": "Group 6403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M408.562,62.832a9.5,9.5,0,0,1,.014,1.329c-.012.821-.028,1.953-.026,3.2s.02,2.384.034,3.2a9.481,9.481,0,0,1-.011,1.33,7.886,7.886,0,0,1-.134-1.324c-.051-.821-.092-1.956-.094-3.21s.038-2.389.087-3.21A7.72,7.72,0,0,1,408.562,62.832Z",
    transform: "translate(-408.345 -62.832)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6408",
    "data-name": "Group 6408",
    transform: "translate(8.878 3.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6407",
    "data-name": "Group 6407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6406",
    "data-name": "Group 6406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M398.063,73.641c-.048.03-1.069-1.553-2.279-3.534s-2.153-3.611-2.105-3.641,1.068,1.553,2.279,3.534S398.111,73.611,398.063,73.641Z",
    transform: "translate(-393.677 -66.466)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6411",
    "data-name": "Group 6411",
    transform: "translate(1.545 12.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6410",
    "data-name": "Group 6410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6409",
    "data-name": "Group 6409"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M391.8,79.529a4.826,4.826,0,0,1-1.03-.163c-.63-.133-1.494-.344-2.436-.621s-1.783-.57-2.384-.8a4.874,4.874,0,0,1-.954-.422,5.84,5.84,0,0,1,1,.286c.612.2,1.456.464,2.394.741s1.793.509,2.413.677A5.766,5.766,0,0,1,391.8,79.529Z",
    transform: "translate(-385 -77.518)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6414",
    "data-name": "Group 6414",
    transform: "translate(0 21.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6413",
    "data-name": "Group 6413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6412",
    "data-name": "Group 6412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M389.374,88.7a47.684,47.684,0,0,1-6.2.6,47.689,47.689,0,0,1,6.2-.6Z",
    transform: "translate(-383.172 -88.685)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Birds",
    transform: "translate(69.465 49.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6418",
    "data-name": "Group 6418",
    transform: "translate(0 32.756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6417",
    "data-name": "Group 6417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6416",
    "data-name": "Group 6416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M107.995,90.842c-.01.026-.472-.163-1.346-.357a10.743,10.743,0,0,0-3.757-.145,10.11,10.11,0,0,0-5.063,2.184A10.5,10.5,0,0,0,94.254,98.2l-.016.063-.1.406-.155-.385A11.283,11.283,0,0,0,89.7,93.115a10.922,10.922,0,0,0-5.225-1.743,11.544,11.544,0,0,0-3.734.342c-.862.227-1.318.427-1.328.4a1.787,1.787,0,0,1,.325-.156,8.03,8.03,0,0,1,.974-.347A11.152,11.152,0,0,1,89.835,92.9a11.429,11.429,0,0,1,4.4,5.276l-.26.02.017-.064a10.666,10.666,0,0,1,3.681-5.808,10.2,10.2,0,0,1,5.2-2.18,10.337,10.337,0,0,1,3.807.233,7.566,7.566,0,0,1,.99.314A1.755,1.755,0,0,1,107.995,90.842Z",
    transform: "translate(-79.412 -90.07)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6421",
    "data-name": "Group 6421",
    transform: "translate(37.751 41.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6420",
    "data-name": "Group 6420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6419",
    "data-name": "Group 6419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M139.8,100.7c-.008.023-.265-.074-.746-.173a6.013,6.013,0,0,0-2.055-.059,5.55,5.55,0,0,0-2.755,1.2,5.745,5.745,0,0,0-1.941,3.091l-.008.034-.1.406-.155-.385A6.172,6.172,0,0,0,129.709,102a6,6,0,0,0-2.846-.963,6.489,6.489,0,0,0-2.044.168c-.474.117-.727.22-.736.2s.056-.042.174-.1a4.108,4.108,0,0,1,.534-.2,6.113,6.113,0,0,1,5.055.685,6.324,6.324,0,0,1,2.444,2.927l-.26.021.009-.036a5.907,5.907,0,0,1,2.049-3.225,5.71,5.71,0,0,1,4.993-1.05,3.777,3.777,0,0,1,.543.184C139.745,100.664,139.806,100.7,139.8,100.7Z",
    transform: "translate(-124.082 -100.241)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6424",
    "data-name": "Group 6424",
    transform: "translate(26.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6423",
    "data-name": "Group 6423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6422",
    "data-name": "Group 6422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M123.945,51.311c.017.018-.257.295-.723.819a17.78,17.78,0,0,0-1.763,2.381,17.357,17.357,0,0,0-2.618,9.265v.117l-.272.022a15.242,15.242,0,0,0-1.694-5.017,15.819,15.819,0,0,0-4.815-5.38c-.57-.395-.9-.593-.889-.614a1.089,1.089,0,0,1,.253.121c.159.092.406.21.695.406a13.93,13.93,0,0,1,2.313,1.848,15.312,15.312,0,0,1,4.407,8.6l-.271.022v-.118a17.049,17.049,0,0,1,2.728-9.371,15.579,15.579,0,0,1,1.848-2.349c.237-.26.449-.437.582-.566A1.114,1.114,0,0,1,123.945,51.311Z",
    transform: "translate(-111.171 -51.31)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Ball",
    transform: "translate(39.349 202.369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6433",
    "data-name": "Group 6433",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6428",
    "data-name": "Group 6428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6425",
    "data-name": "Group 6425",
    transform: "translate(0.22 0.179)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 9.925,
    cy: 9.925,
    r: 9.925,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6427",
    "data-name": "Group 6427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6426",
    "data-name": "Group 6426"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M63.845,242.188a19.729,19.729,0,0,0-.394-2.4,9.889,9.889,0,0,0-3.62-5.362,9.739,9.739,0,0,0-9.222-1.366A9.736,9.736,0,0,0,46.1,236.45a9.672,9.672,0,0,0,0,11.476,9.754,9.754,0,0,0,4.508,3.393,9.823,9.823,0,0,0,12.842-6.729,19.7,19.7,0,0,0,.394-2.4,3.443,3.443,0,0,1,.012.636,4.5,4.5,0,0,1-.057.769,6.934,6.934,0,0,1-.183,1.039,10,10,0,0,1-7.832,7.483,10.112,10.112,0,0,1-5.316-.416,10.116,10.116,0,0,1-4.717-3.519,10.07,10.07,0,0,1,0-11.987,10.12,10.12,0,0,1,4.716-3.517,10.108,10.108,0,0,1,5.315-.416,10,10,0,0,1,7.833,7.483,7.025,7.025,0,0,1,.183,1.04,4.5,4.5,0,0,1,.057.769A3.443,3.443,0,0,1,63.845,242.188Z",
    transform: "translate(-43.776 -232.085)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6430",
    "data-name": "Group 6430",
    transform: "translate(0.295 6.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6429",
    "data-name": "Group 6429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M62.865,239.2a2.6,2.6,0,0,1-.511.624,13.6,13.6,0,0,1-1.649,1.448,15.94,15.94,0,0,1-13.813,2.615,13.482,13.482,0,0,1-2.064-.745,2.585,2.585,0,0,1-.7-.393c.031-.073,1.066.421,2.844.837a16.861,16.861,0,0,0,13.554-2.566C62.026,239.983,62.81,239.146,62.865,239.2Z",
    transform: "translate(-44.126 -239.199)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6432",
    "data-name": "Group 6432",
    transform: "translate(0.628 8.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6431",
    "data-name": "Group 6431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M63.789,242.61a2.7,2.7,0,0,1-.534.629,13.8,13.8,0,0,1-1.711,1.457,16.752,16.752,0,0,1-6.8,2.9,16.979,16.979,0,0,1-7.385-.3,14.214,14.214,0,0,1-2.12-.745,2.685,2.685,0,0,1-.724-.394c.03-.073,1.1.421,2.92.836a18.233,18.233,0,0,0,7.231.172,18,18,0,0,0,6.7-2.725C62.921,243.4,63.734,242.552,63.789,242.61Z",
    transform: "translate(-44.519 -242.608)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(128.169 40.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6944",
    "data-name": "Group 6944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6531",
    "data-name": "Group 6531",
    transform: "translate(199.331 278.902)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6530",
    "data-name": "Group 6530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6446",
    "data-name": "Group 6446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6445",
    "data-name": "Group 6445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6444",
    "data-name": "Group 6444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6443",
    "data-name": "Group 6443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6442",
    "data-name": "Group 6442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6441",
    "data-name": "Group 6441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6440",
    "data-name": "Group 6440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6439",
    "data-name": "Group 6439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6438",
    "data-name": "Group 6438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6437",
    "data-name": "Group 6437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6436",
    "data-name": "Group 6436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6435",
    "data-name": "Group 6435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6434",
    "data-name": "Group 6434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M390.384,403.062l24.594-6.648s15.017,22.766,19.681,21.98l-11.177-48.149-38.745,8.786Z",
    transform: "translate(-384.737 -370.245)",
    fill: "#fff"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6460",
    "data-name": "Group 6460",
    transform: "translate(24.676 9.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6459",
    "data-name": "Group 6459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6458",
    "data-name": "Group 6458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6457",
    "data-name": "Group 6457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6456",
    "data-name": "Group 6456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6455",
    "data-name": "Group 6455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6454",
    "data-name": "Group 6454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6453",
    "data-name": "Group 6453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6452",
    "data-name": "Group 6452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6451",
    "data-name": "Group 6451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6450",
    "data-name": "Group 6450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6449",
    "data-name": "Group 6449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6448",
    "data-name": "Group 6448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6447",
    "data-name": "Group 6447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M413.958,383.821a2.018,2.018,0,0,1,1.928-1.88,1.94,1.94,0,0,1,1.881,1.895,2.129,2.129,0,0,1-2.053,1.981,2.013,2.013,0,0,1-1.738-2.188",
    transform: "translate(-413.935 -381.941)",
    fill: "#fff"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6473",
    "data-name": "Group 6473",
    transform: "translate(34.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6472",
    "data-name": "Group 6472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6471",
    "data-name": "Group 6471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6470",
    "data-name": "Group 6470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6469",
    "data-name": "Group 6469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6468",
    "data-name": "Group 6468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6467",
    "data-name": "Group 6467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6466",
    "data-name": "Group 6466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6465",
    "data-name": "Group 6465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6464",
    "data-name": "Group 6464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6463",
    "data-name": "Group 6463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6462",
    "data-name": "Group 6462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6461",
    "data-name": "Group 6461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M429.874,370.245,426,371.284l12.164,45.776s1.43,1.927,2.884,1.334Z",
    transform: "translate(-426.003 -370.245)",
    fill: "#fff"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6487",
    "data-name": "Group 6487",
    transform: "translate(29.697 22.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6486",
    "data-name": "Group 6486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6485",
    "data-name": "Group 6485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6484",
    "data-name": "Group 6484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6483",
    "data-name": "Group 6483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6482",
    "data-name": "Group 6482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6481",
    "data-name": "Group 6481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6480",
    "data-name": "Group 6480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6479",
    "data-name": "Group 6479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6478",
    "data-name": "Group 6478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6477",
    "data-name": "Group 6477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6476",
    "data-name": "Group 6476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6475",
    "data-name": "Group 6475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6474",
    "data-name": "Group 6474"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M420.356,401.284c.234-.063.068-1.263.555-2.6.452-1.345,1.333-2.178,1.189-2.372-.1-.206-1.421.471-1.983,2.094S420.152,401.385,420.356,401.284Z",
    transform: "translate(-419.877 -396.28)",
    fill: "#fff"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6501",
    "data-name": "Group 6501",
    transform: "translate(33.245 27.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6500",
    "data-name": "Group 6500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6499",
    "data-name": "Group 6499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6498",
    "data-name": "Group 6498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6497",
    "data-name": "Group 6497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6496",
    "data-name": "Group 6496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6495",
    "data-name": "Group 6495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6494",
    "data-name": "Group 6494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6493",
    "data-name": "Group 6493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6492",
    "data-name": "Group 6492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6491",
    "data-name": "Group 6491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6490",
    "data-name": "Group 6490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6489",
    "data-name": "Group 6489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6488",
    "data-name": "Group 6488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M424.268,406.877c.24,0,.4-1.11,1.213-2.14.779-1.053,1.808-1.5,1.743-1.736-.014-.23-1.429-.073-2.41,1.226S424.043,406.923,424.268,406.877Z",
    transform: "translate(-424.075 -402.913)",
    fill: "#fff"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6515",
    "data-name": "Group 6515",
    transform: "translate(36.493 32.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6514",
    "data-name": "Group 6514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6513",
    "data-name": "Group 6513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6512",
    "data-name": "Group 6512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6511",
    "data-name": "Group 6511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6510",
    "data-name": "Group 6510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6509",
    "data-name": "Group 6509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6508",
    "data-name": "Group 6508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6507",
    "data-name": "Group 6507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6506",
    "data-name": "Group 6506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6505",
    "data-name": "Group 6505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6504",
    "data-name": "Group 6504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6503",
    "data-name": "Group 6503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6502",
    "data-name": "Group 6502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M431.573,409.31c0-.225-1.25-.28-2.4.623s-1.4,2.121-1.186,2.175c.224.088.75-.786,1.7-1.513C430.628,409.847,431.6,409.549,431.573,409.31Z",
    transform: "translate(-427.918 -409.17)",
    fill: "#fff"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6529",
    "data-name": "Group 6529",
    transform: "translate(22.904 22.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6528",
    "data-name": "Group 6528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6527",
    "data-name": "Group 6527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6526",
    "data-name": "Group 6526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6525",
    "data-name": "Group 6525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6524",
    "data-name": "Group 6524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6523",
    "data-name": "Group 6523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6522",
    "data-name": "Group 6522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6521",
    "data-name": "Group 6521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6520",
    "data-name": "Group 6520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6519",
    "data-name": "Group 6519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6518",
    "data-name": "Group 6518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6517",
    "data-name": "Group 6517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6516",
    "data-name": "Group 6516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M413.338,402.33c.192-.149-.383-1.152-.6-2.5-.246-1.345-.04-2.483-.27-2.559-.2-.1-.837,1.115-.558,2.7S413.181,402.488,413.338,402.33Z",
    transform: "translate(-411.839 -397.264)",
    fill: "#fff"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6535",
    "data-name": "Group 6535",
    transform: "translate(103.562 216.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6532",
    "data-name": "Group 6532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M271.416,310.792c-.01.8,6.886,39.517,10.143,50.113s7.8,29.77,15.905,34.848,86.319-10.464,86.319-10.464l-3.111-22.543-60.02,1.362-2.216-30.661,1.961-6.057s6.03-20.032,6.12-26.876-33.435-2.6-33.435-2.6Z",
    transform: "translate(-271.416 -296.611)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6534",
    "data-name": "Group 6534",
    transform: "translate(5.939 30.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6533",
    "data-name": "Group 6533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M299.372,332.18c.008.122-4.671.524-10.45.9s-10.471.581-10.479.459,4.67-.523,10.451-.9S299.365,332.059,299.372,332.18Z",
    transform: "translate(-278.444 -332.145)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6536",
    "data-name": "Group 6536",
    transform: "translate(133.656 137.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M324.6,202.789s10.228,10.779,14.095,15.253,4.214,17.507-.25,20.488-21.568-5.014-21.568-5.014l-9.853-17.5Z",
    transform: "translate(-307.026 -202.789)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6538",
    "data-name": "Group 6538",
    transform: "translate(138.527 149.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6537",
    "data-name": "Group 6537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M328.443,239.889a6.033,6.033,0,0,1-1.16-.229,12.837,12.837,0,0,1-1.334-.376l-.826-.265-.905-.358a14.548,14.548,0,0,1-4.11-2.477,9.855,9.855,0,0,1-3.033-5.015,14.192,14.192,0,0,1-.568-3c-.079-.982-.09-1.924-.147-2.812a11.717,11.717,0,0,0-1.072-4.537,14.475,14.475,0,0,0-2.5-3.54,4.021,4.021,0,0,1,.9.767,10.533,10.533,0,0,1,1.873,2.637,11.627,11.627,0,0,1,1.2,4.646,22.768,22.768,0,0,0,.734,5.722,9.617,9.617,0,0,0,2.882,4.833,14.972,14.972,0,0,0,3.96,2.492C326.815,239.443,328.47,239.8,328.443,239.889Z",
    transform: "translate(-312.789 -217.277)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6540",
    "data-name": "Group 6540",
    transform: "translate(146.204 139.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6539",
    "data-name": "Group 6539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M340.463,221.513c-.079.092-4.306-3.416-9.437-7.834s-9.23-8.076-9.151-8.168,4.3,3.415,9.437,7.835S340.542,221.421,340.463,221.513Z",
    transform: "translate(-321.874 -205.509)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6556",
    "data-name": "Group 6556",
    transform: "translate(47.946 102.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6541",
    "data-name": "Group 6541",
    transform: "translate(62.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M280.138,162.472s4.482-2.34,10.905.87S323.416,191,323.416,191l-20.058,19.526L285.32,191.891Z",
    transform: "translate(-280.138 -161.649)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6542",
    "data-name": "Group 6542",
    transform: "translate(5.902 0.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M225.6,171.689l-2.931,8.858-10.079,7.2,11.9,37.51,33.4,43.34,58.1-13.2-6.764-15.751-26.284-46.686-13.266-30.373-10.988,2.8-9.682-3.038Z",
    transform: "translate(-212.592 -162.336)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6543",
    "data-name": "Group 6543",
    transform: "translate(0 25.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M214.143,191.507s-11.135,1.333-7.969,16.9,27.154,26.976,27.154,26.976l12.749-13.272-3.937-21.238Z",
    transform: "translate(-205.607 -191.507)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6545",
    "data-name": "Group 6545",
    transform: "translate(15.869 27.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6544",
    "data-name": "Group 6544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M240.164,200.241a13.512,13.512,0,0,1-2.341-.767l-5.547-2.1c-2.167-.812-4.144-1.5-5.58-1.988a15.6,15.6,0,0,1-2.311-.847,12.145,12.145,0,0,1,2.4.549c1.465.412,3.468,1.059,5.643,1.873s4.112,1.62,5.508,2.219A13.735,13.735,0,0,1,240.164,200.241Z",
    transform: "translate(-224.385 -194.534)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6547",
    "data-name": "Group 6547",
    transform: "translate(16.02 18.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6546",
    "data-name": "Group 6546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M249.3,188.124a5.076,5.076,0,0,1-.989-.316l-2.677-1.013.2-.157a17.4,17.4,0,0,1,.144,4.835l-.027.244-.234-.08-6.5-2.237c-4.064-1.413-7.735-2.715-10.386-3.678l-3.131-1.163a6.583,6.583,0,0,1-1.128-.483,6.531,6.531,0,0,1,1.185.321l3.177,1.03c2.676.888,6.364,2.143,10.428,3.556l6.488,2.28-.26.163a18.2,18.2,0,0,0-.039-4.744l-.036-.258.235.1,2.627,1.137A5.147,5.147,0,0,1,249.3,188.124Z",
    transform: "translate(-224.564 -184.072)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6549",
    "data-name": "Group 6549",
    transform: "translate(42.335 4.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6548",
    "data-name": "Group 6548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M263.4,167.292a4.912,4.912,0,0,1,.189,1.05c.085.681.192,1.67.268,2.9a59.742,59.742,0,0,1-.194,9.59c-.083.86-.191,1.7-.3,2.51l-.036.265-.252-.092a29.7,29.7,0,0,1-6.195-3.14l.243-.124a7.518,7.518,0,0,1-.805,2.922,3.124,3.124,0,0,1-.616.922c-.031-.019.181-.352.458-1a8.067,8.067,0,0,0,.649-2.863l.01-.27.232.145a32.824,32.824,0,0,0,6.172,3l-.288.173c.1-.8.21-1.639.292-2.494a73.568,73.568,0,0,0,.321-9.532c-.036-1.222-.1-2.21-.128-2.894A5.1,5.1,0,0,1,263.4,167.292Z",
    transform: "translate(-255.701 -167.292)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6551",
    "data-name": "Group 6551",
    transform: "translate(60.916 58.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6550",
    "data-name": "Group 6550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M303.423,230.892a1.741,1.741,0,0,1-.085.439l-.325,1.236c-.139.537-.326,1.191-.589,1.934s-.518,1.607-.9,2.523c-.359.926-.761,1.938-1.265,2.993-.463,1.073-1.055,2.174-1.658,3.342a56.77,56.77,0,0,1-10.257,13.61c-.956.9-1.851,1.774-2.756,2.515-.876.775-1.737,1.44-2.528,2.041-.775.622-1.531,1.11-2.176,1.563s-1.22.816-1.7,1.1l-1.1.652a1.713,1.713,0,0,1-.4.2,1.706,1.706,0,0,1,.352-.277l1.051-.722c.462-.3,1.023-.682,1.649-1.156s1.369-.974,2.128-1.607c.774-.614,1.619-1.289,2.479-2.07.888-.748,1.768-1.624,2.71-2.528a59.614,59.614,0,0,0,10.186-13.516c.608-1.154,1.208-2.241,1.683-3.3.515-1.041.931-2.039,1.307-2.953.4-.9.681-1.754.959-2.488s.494-1.376.658-1.9l.4-1.209A1.732,1.732,0,0,1,303.423,230.892Z",
    transform: "translate(-277.688 -230.892)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6553",
    "data-name": "Group 6553",
    transform: "translate(55.996 60.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6552",
    "data-name": "Group 6552"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M293.653,233.075a1.406,1.406,0,0,1-.107.393l-.39,1.1c-.34.953-.889,2.311-1.618,3.967a85.8,85.8,0,0,1-15.493,23.522c-1.233,1.324-2.264,2.365-3.005,3.053l-.854.791c-.2.177-.308.264-.319.254a1.461,1.461,0,0,1,.257-.317l.8-.849c.7-.724,1.7-1.795,2.9-3.14A96.067,96.067,0,0,0,291.255,238.4c.763-1.634,1.355-2.97,1.743-3.9l.466-1.066A1.467,1.467,0,0,1,293.653,233.075Z",
    transform: "translate(-271.866 -233.075)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6555",
    "data-name": "Group 6555",
    transform: "translate(73.853 25.928)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6554",
    "data-name": "Group 6554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M293,192.329a5.1,5.1,0,0,1,.522.941l1.3,2.62c1.1,2.211,2.638,5.251,4.442,8.554s3.531,6.245,4.8,8.362c.6,1,1.1,1.839,1.5,2.507a5.128,5.128,0,0,1,.51.947,5.03,5.03,0,0,1-.654-.854c-.4-.565-.954-1.4-1.623-2.436-1.339-2.078-3.111-5-4.922-8.314s-3.311-6.382-4.337-8.632c-.513-1.125-.914-2.042-1.174-2.682A5.022,5.022,0,0,1,293,192.329Z",
    transform: "translate(-292.996 -192.329)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6560",
    "data-name": "Group 6560",
    transform: "translate(66.565 114.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6557",
    "data-name": "Group 6557",
    transform: "translate(0.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M234.767,201.173a2.426,2.426,0,0,1,2.043-.287h0s6.069-6.571,18.232-11.707,24.437-13.6,24.437-13.6l5.216,9.514s-17.9,22.217-24.058,25.975-17.228,11.357-23.1,11.784-8.356-.1-8.356-.1-2.907-7.145.167-13.72C230.937,205.862,232.508,202.653,234.767,201.173Z",
    transform: "translate(-227.939 -175.576)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6559",
    "data-name": "Group 6559",
    transform: "translate(0 25.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6558",
    "data-name": "Group 6558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M236.763,205.5a3.34,3.34,0,0,0-1.059.094,5.453,5.453,0,0,0-2.36,1.645,25.425,25.425,0,0,0-4.521,8.555,18.683,18.683,0,0,0-.776,5.274,16.753,16.753,0,0,0,.572,4.319,22.369,22.369,0,0,0,1.52,3.741c-.013.008-.076-.067-.185-.218a6.989,6.989,0,0,1-.441-.685,13.155,13.155,0,0,1-1.192-2.753,16.038,16.038,0,0,1-.679-4.4,18.277,18.277,0,0,1,.76-5.4,23.159,23.159,0,0,1,2.157-5,20.961,20.961,0,0,1,2.559-3.642,5.316,5.316,0,0,1,2.546-1.6,2.156,2.156,0,0,1,.829-.025C236.677,205.447,236.767,205.489,236.763,205.5Z",
    transform: "translate(-227.638 -205.375)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6582",
    "data-name": "Group 6582",
    transform: "translate(103.553 281.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6564",
    "data-name": "Group 6564",
    transform: "translate(0 21.901)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6561",
    "data-name": "Group 6561",
    transform: "translate(0.011 0.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M271.838,407.908s22.565,10,29.038,9.563c0,0,1.022,3.972,6.521.988,0,0,3.528,5.964,7.73,1.072,0,0,3.042,1.94,6.476-2.469l76.679-7.915a4.725,4.725,0,0,0,4.217-5.162h0a4.72,4.72,0,0,0-4.887-4.258c-18.245.739-86.693,3.4-93.808,1.984-8.216-1.633-25.507,1.491-29.239,2.876C274.565,404.586,270.05,405.895,271.838,407.908Z",
    transform: "translate(-271.419 -399.721)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6563",
    "data-name": "Group 6563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6562",
    "data-name": "Group 6562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M271.836,407.869s-.065-.074-.193-.243a1.185,1.185,0,0,1-.223-.911,2.169,2.169,0,0,1,1.012-1.247,8.43,8.43,0,0,1,2.115-.976l0,0a52.577,52.577,0,0,1,7.257-1.728c3-.538,6.561-1.09,10.637-1.427,2.037-.177,4.205-.275,6.491-.247a33.763,33.763,0,0,1,3.511.226c1.2.2,2.4.335,3.637.433,4.992.236,10.44.169,16.257.1,11.64-.161,24.794-.559,39.02-1.027l22.085-.8,11.542-.45c.98-.032,1.936-.093,2.945-.1a4.891,4.891,0,0,1,2.863,1.006,4.946,4.946,0,0,1-.133,7.962,5.168,5.168,0,0,1-1.347.677,6.971,6.971,0,0,1-1.461.259l-5.7.588-11.194,1.153-21.431,2.2-37.907,3.88.121-.067a8.356,8.356,0,0,1-2.978,2.518,4.165,4.165,0,0,1-3.726-.017l.215-.032c-.3.3-.58.62-.9.889a5.156,5.156,0,0,1-1.058.688,3.417,3.417,0,0,1-2.445.289,5.13,5.13,0,0,1-2.085-1.187,8.438,8.438,0,0,1-1.5-1.782l.2.056a7.649,7.649,0,0,1-3.844,1.108,3.168,3.168,0,0,1-1.82-.644,3.134,3.134,0,0,1-1.063-1.55l.143.1a16.771,16.771,0,0,1-3.547-.385l-1.662-.374-1.594-.434c-2.087-.593-4.018-1.237-5.806-1.866-3.574-1.263-6.58-2.456-9.015-3.444s-4.288-1.792-5.538-2.338l-1.413-.63c-.316-.144-.472-.228-.472-.228s.167.06.488.193l1.427.6c1.26.523,3.125,1.3,5.564,2.271s5.454,2.137,9.03,3.379c1.788.618,3.719,1.251,5.8,1.832l1.59.426,1.651.363a16.607,16.607,0,0,0,3.478.367l.112,0,.031.1a2.814,2.814,0,0,0,2.63,1.974,7.394,7.394,0,0,0,3.685-1.086l.123-.066.08.122a6.365,6.365,0,0,0,3.4,2.815,3.089,3.089,0,0,0,2.225-.274,4.82,4.82,0,0,0,.989-.647c.306-.257.571-.569.862-.853l.1-.1.117.064a3.845,3.845,0,0,0,3.4-.014,8.027,8.027,0,0,0,2.843-2.423l.046-.059.075-.008,37.9-3.945,21.43-2.221,11.193-1.158,5.7-.588a6.573,6.573,0,0,0,1.372-.241,4.716,4.716,0,0,0,1.226-.616,4.5,4.5,0,0,0,1.638-2.175,4.485,4.485,0,0,0-1.516-5.078,4.448,4.448,0,0,0-2.608-.916c-.952.008-1.949.07-2.917.1l-11.543.445-22.089.777c-14.227.452-27.383.827-39.029.959-5.822.059-11.267.11-16.28-.144-1.257-.1-2.491-.252-3.654-.448a34.059,34.059,0,0,0-3.48-.237c-2.273-.037-4.434.051-6.467.217-4.066.317-7.623.847-10.624,1.363a54.552,54.552,0,0,0-7.249,1.656l0,0h0c-1.667.527-2.906,1.273-3.1,2.125a1.167,1.167,0,0,0,.189.881C271.783,407.778,271.836,407.869,271.836,407.869Z",
    transform: "translate(-271.406 -399.469)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6565",
    "data-name": "Group 6565",
    transform: "translate(76.699 0.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M362.162,397.739l.515-24.064,7.039.041.973,23.429Z",
    transform: "translate(-362.162 -373.675)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6566",
    "data-name": "Group 6566",
    transform: "translate(103.937 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M394.392,373.624l3.035,23.6,9.364-.953-5.384-22.721Z",
    transform: "translate(-394.392 -373.554)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6567",
    "data-name": "Group 6567",
    transform: "translate(29.715 1.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M326.125,375.811,306.567,399.4l14.676,4.916.108-1.128,7.973-27.838Z",
    transform: "translate(-306.567 -375.353)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6569",
    "data-name": "Group 6569",
    transform: "translate(29.225 24.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6568",
    "data-name": "Group 6568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M307.266,402.189a15.825,15.825,0,0,1-.262,2.344c-.189,1.441-.409,3.435-.521,5.645s-.091,4.218-.047,5.671a15.668,15.668,0,0,1,.025,2.359,10.481,10.481,0,0,1-.336-2.342,44.23,44.23,0,0,1,.572-11.381A10.464,10.464,0,0,1,307.266,402.189Z",
    transform: "translate(-305.987 -402.189)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6571",
    "data-name": "Group 6571",
    transform: "translate(35.893 23.885)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6570",
    "data-name": "Group 6570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M314.969,401.816a16.463,16.463,0,0,1-.151,2.528c-.132,1.555-.3,3.7-.415,6.078s-.15,4.531-.167,6.092a16.386,16.386,0,0,1-.09,2.53,12.894,12.894,0,0,1-.221-2.526c-.063-1.564-.074-3.729.039-6.117s.333-4.54.545-6.092A12.9,12.9,0,0,1,314.969,401.816Z",
    transform: "translate(-313.878 -401.816)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6573",
    "data-name": "Group 6573",
    transform: "translate(42.903 24.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6572",
    "data-name": "Group 6572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M322.526,402.914a16.069,16.069,0,0,1,.046,2.475c-.008,1.525,0,3.631.091,5.954s.254,4.423.385,5.944a16.076,16.076,0,0,1,.152,2.47,12.1,12.1,0,0,1-.461-2.436c-.21-1.516-.42-3.624-.515-5.96s-.052-4.453.037-5.981A12.154,12.154,0,0,1,322.526,402.914Z",
    transform: "translate(-322.172 -402.914)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6575",
    "data-name": "Group 6575",
    transform: "translate(49.297 24.063)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6574",
    "data-name": "Group 6574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M330.111,402.027a13.583,13.583,0,0,1,.04,2.286c-.014,1.409-.013,3.353.068,5.5s.229,4.084.349,5.487a13.712,13.712,0,0,1,.134,2.282,10.339,10.339,0,0,1-.444-2.247c-.2-1.4-.4-3.347-.479-5.506s-.032-4.113.061-5.525A10.45,10.45,0,0,1,330.111,402.027Z",
    transform: "translate(-329.737 -402.027)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6577",
    "data-name": "Group 6577",
    transform: "translate(29.754 21.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6576",
    "data-name": "Group 6576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M401.879,399.426a.992.992,0,0,1-.245.031l-.721.047-2.775.14-10.206.434-33.679,1.263-18.544.642c-2.847.09-5.56.236-8.1.112-2.537-.083-4.9-.212-7.05-.322-4.306-.231-7.791-.346-10.2-.346-1.205,0-2.141.005-2.775.019l-.723.007a1.034,1.034,0,0,1-.247-.013,1.017,1.017,0,0,1,.245-.032l.721-.051c.634-.043,1.57-.08,2.777-.1,2.414-.052,5.908.016,10.217.208,2.155.09,4.514.2,7.046.267,2.53.108,5.233-.05,8.084-.151l18.542-.678,33.679-1.133,10.21-.294,2.777-.057.723,0A1.044,1.044,0,0,1,401.879,399.426Z",
    transform: "translate(-306.613 -399.412)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6579",
    "data-name": "Group 6579",
    transform: "translate(50.002 26.042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6578",
    "data-name": "Group 6578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M405.3,404.375c.012.121-16.707,1.864-37.339,3.893s-37.373,3.578-37.385,3.457,16.7-1.863,37.342-3.894S405.284,404.253,405.3,404.375Z",
    transform: "translate(-330.572 -404.368)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6581",
    "data-name": "Group 6581",
    transform: "translate(50.607 29.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6580",
    "data-name": "Group 6580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M406.44,408.3c.013.121-16.8,1.958-37.551,4.1s-37.588,3.787-37.6,3.666,16.8-1.958,37.555-4.1S406.427,408.176,406.44,408.3Z",
    transform: "translate(-331.288 -408.291)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6709",
    "data-name": "Group 6709",
    transform: "translate(0 183.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6680",
    "data-name": "Group 6680",
    transform: "translate(0 103.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6679",
    "data-name": "Group 6679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6595",
    "data-name": "Group 6595",
    transform: "translate(0.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6594",
    "data-name": "Group 6594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6593",
    "data-name": "Group 6593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6592",
    "data-name": "Group 6592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6591",
    "data-name": "Group 6591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6590",
    "data-name": "Group 6590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6589",
    "data-name": "Group 6589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6588",
    "data-name": "Group 6588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6587",
    "data-name": "Group 6587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6586",
    "data-name": "Group 6586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6585",
    "data-name": "Group 6585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6584",
    "data-name": "Group 6584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6583",
    "data-name": "Group 6583"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M174.756,379.565l.32,25.474s-25.785,8.881-26.185,13.594l49.415,1.152,1.129-39.713Z",
    transform: "translate(-148.891 -379.565)",
    fill: "#fff"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6609",
    "data-name": "Group 6609",
    transform: "translate(39.076 23.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6608",
    "data-name": "Group 6608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6607",
    "data-name": "Group 6607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6606",
    "data-name": "Group 6606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6605",
    "data-name": "Group 6605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6604",
    "data-name": "Group 6604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6603",
    "data-name": "Group 6603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6602",
    "data-name": "Group 6602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6601",
    "data-name": "Group 6601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6600",
    "data-name": "Group 6600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6599",
    "data-name": "Group 6599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6598",
    "data-name": "Group 6598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6597",
    "data-name": "Group 6597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6596",
    "data-name": "Group 6596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M197.565,407.579a2.018,2.018,0,0,1,1.341,2.335,1.941,1.941,0,0,1-2.3,1.35,2.13,2.13,0,0,1-1.408-2.481,2.013,2.013,0,0,1,2.551-1.138",
    transform: "translate(-195.112 -407.484)",
    fill: "#fff"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6622",
    "data-name": "Group 6622",
    transform: "translate(0 36.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6621",
    "data-name": "Group 6621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6620",
    "data-name": "Group 6620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6619",
    "data-name": "Group 6619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6618",
    "data-name": "Group 6618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6617",
    "data-name": "Group 6617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6616",
    "data-name": "Group 6616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6615",
    "data-name": "Group 6615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6614",
    "data-name": "Group 6614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6613",
    "data-name": "Group 6613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6612",
    "data-name": "Group 6612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6611",
    "data-name": "Group 6611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6610",
    "data-name": "Group 6610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M198.3,426.424l-.043-4.008-47.363.393s-2.222.906-2.01,2.462Z",
    transform: "translate(-148.874 -422.416)",
    fill: "#fff"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6636",
    "data-name": "Group 6636",
    transform: "translate(25.403 24.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6635",
    "data-name": "Group 6635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6634",
    "data-name": "Group 6634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6633",
    "data-name": "Group 6633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6632",
    "data-name": "Group 6632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6631",
    "data-name": "Group 6631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6630",
    "data-name": "Group 6630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6629",
    "data-name": "Group 6629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6628",
    "data-name": "Group 6628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6627",
    "data-name": "Group 6627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6626",
    "data-name": "Group 6626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6625",
    "data-name": "Group 6625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6624",
    "data-name": "Group 6624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6623",
    "data-name": "Group 6623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M178.934,409.35c0,.242,1.207.379,2.376,1.182,1.191.773,1.778,1.833,2,1.743.224-.041-.1-1.492-1.536-2.441S178.886,409.128,178.934,409.35Z",
    transform: "translate(-178.933 -409.144)",
    fill: "#fff"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6650",
    "data-name": "Group 6650",
    transform: "translate(20.169 27.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6649",
    "data-name": "Group 6649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6648",
    "data-name": "Group 6648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6647",
    "data-name": "Group 6647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6646",
    "data-name": "Group 6646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6645",
    "data-name": "Group 6645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6644",
    "data-name": "Group 6644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6643",
    "data-name": "Group 6643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6642",
    "data-name": "Group 6642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6641",
    "data-name": "Group 6641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6640",
    "data-name": "Group 6640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6639",
    "data-name": "Group 6639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6638",
    "data-name": "Group 6638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6637",
    "data-name": "Group 6637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M172.742,411.765c-.06.232.975.667,1.771,1.706.827,1.017,1.007,2.125,1.248,2.12.226.044.426-1.366-.588-2.639S172.753,411.534,172.742,411.765Z",
    transform: "translate(-172.739 -411.673)",
    fill: "#fff"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6664",
    "data-name": "Group 6664",
    transform: "translate(15.246 29.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6663",
    "data-name": "Group 6663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6662",
    "data-name": "Group 6662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6661",
    "data-name": "Group 6661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6660",
    "data-name": "Group 6660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6659",
    "data-name": "Group 6659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6658",
    "data-name": "Group 6658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6657",
    "data-name": "Group 6657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6656",
    "data-name": "Group 6656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6655",
    "data-name": "Group 6655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6654",
    "data-name": "Group 6654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6653",
    "data-name": "Group 6653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6652",
    "data-name": "Group 6652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6651",
    "data-name": "Group 6651"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M168.751,418.27c.218.056.582-1.142-.007-2.477s-1.705-1.889-1.812-1.69c-.141.2.575.921,1.041,2.026C168.467,417.221,168.512,418.24,168.751,418.27Z",
    transform: "translate(-166.915 -414.063)",
    fill: "#fff"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6678",
    "data-name": "Group 6678",
    transform: "translate(25.968 18.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6677",
    "data-name": "Group 6677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6676",
    "data-name": "Group 6676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6675",
    "data-name": "Group 6675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6674",
    "data-name": "Group 6674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6673",
    "data-name": "Group 6673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6672",
    "data-name": "Group 6672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6671",
    "data-name": "Group 6671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6670",
    "data-name": "Group 6670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6669",
    "data-name": "Group 6669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6668",
    "data-name": "Group 6668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6667",
    "data-name": "Group 6667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6666",
    "data-name": "Group 6666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6665",
    "data-name": "Group 6665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M179.609,402.36c.1.222,1.211-.085,2.573.04,1.364.1,2.414.579,2.545.375.144-.172-.871-1.088-2.478-1.213S179.494,402.167,179.609,402.36Z",
    transform: "translate(-179.601 -401.545)",
    fill: "#fff"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6684",
    "data-name": "Group 6684",
    transform: "translate(21.88 9.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6681",
    "data-name": "Group 6681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M280.968,269.713s-76.817,7.647-83.43,9.647-12.655,14.063-15.5,19.923-7.273,84.52-7.273,84.52l28.1,1.622s4.775-48.537,5.868-56.49a95.841,95.841,0,0,0,.219-17.921s77.167,8.709,84.545,8,15.93-8.925,18.353-17.123c3.117-10.547-4.306-29.554-4.306-29.554s-5.916-2.909-10.655-3.2A93.731,93.731,0,0,0,280.968,269.713Z",
    transform: "translate(-174.764 -269.014)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6683",
    "data-name": "Group 6683",
    transform: "translate(19.697 24.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6682",
    "data-name": "Group 6682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M282.911,297.737a.812.812,0,0,1-.217.035l-.641.057-2.467.178c-2.142.149-5.246.331-9.081.531-7.67.4-18.274.824-29.992,1.045s-22.335.189-30.015.074c-3.84-.057-6.947-.123-9.093-.192l-2.472-.086-.642-.034a.844.844,0,0,1-.219-.026.791.791,0,0,1,.22-.019l.643-.01,2.473,0,9.093.052c7.679.035,18.287.013,30-.2s22.314-.594,29.985-.915l9.086-.39,2.471-.1.644-.014A.812.812,0,0,1,282.911,297.737Z",
    transform: "translate(-198.071 -297.727)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6706",
    "data-name": "Group 6706",
    transform: "translate(15.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6688",
    "data-name": "Group 6688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6685",
    "data-name": "Group 6685",
    transform: "translate(0.153 0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M184.987,257.694s-12.419,21.328-12.7,27.809c0,0-4.06.579-1.7,6.373,0,0-6.316,2.851-1.916,7.565,0,0-2.263,2.809,1.742,6.708l.008,77.723a4.726,4.726,0,0,0,4.668,4.725h0a4.721,4.721,0,0,0,4.774-4.424c1.15-18.347,5.58-87.11,7.767-94.025,2.527-7.987,1.324-25.516.358-29.379C187.989,260.771,187.184,256.139,184.987,257.694Z",
    transform: "translate(-167.113 -257.375)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6687",
    "data-name": "Group 6687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6686",
    "data-name": "Group 6686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M184.959,257.693s.081-.057.263-.164a1.177,1.177,0,0,1,.93-.122,2.167,2.167,0,0,1,1.127,1.143,8.411,8.411,0,0,1,.738,2.209v0a52.826,52.826,0,0,1,.92,7.428c.2,3.054.363,6.666.244,10.771a64.4,64.4,0,0,1-.479,6.506,32.271,32.271,0,0,1-.626,3.477c-.328,1.176-.594,2.354-.813,3.585-.756,4.962-1.259,10.41-1.789,16.23-1.05,11.645-2.014,24.829-3.02,39.092-.481,7.133-.979,14.535-1.492,22.151q-.366,5.712-.743,11.579c-.069.984-.106,1.944-.2,2.954a4.881,4.881,0,0,1-1.316,2.749,4.95,4.95,0,0,1-7.927-1.045,5.241,5.241,0,0,1-.51-1.431,7.587,7.587,0,0,1-.09-1.489v-5.771q0-5.739,0-11.337c0-7.459,0-14.711.007-21.7.01-13.979.02-26.91.029-38.354l.053.126a8.35,8.35,0,0,1-2.175-3.238,4.164,4.164,0,0,1,.427-3.7l.008.217c-.262-.335-.552-.645-.785-1a5.151,5.151,0,0,1-.566-1.128,3.408,3.408,0,0,1-.018-2.462,5.126,5.126,0,0,1,1.41-1.94,8.4,8.4,0,0,1,1.934-1.29l-.078.194a7.66,7.66,0,0,1-.679-3.943,3.174,3.174,0,0,1,.841-1.737,3.135,3.135,0,0,1,1.657-.886l-.118.13a16.741,16.741,0,0,1,.774-3.484q.28-.816.554-1.611l.607-1.536c.82-2.009,1.672-3.858,2.494-5.566,1.65-3.413,3.166-6.27,4.415-8.58s2.253-4.065,2.933-5.247l.783-1.334c.177-.3.278-.445.278-.445s-.078.159-.245.464l-.749,1.353c-.658,1.193-1.634,2.962-2.869,5.279s-2.725,5.186-4.352,8.6c-.81,1.71-1.652,3.56-2.459,5.564l-.6,1.533q-.267.79-.543,1.6a16.6,16.6,0,0,0-.747,3.416l-.011.112-.106.019a2.814,2.814,0,0,0-2.252,2.4,7.4,7.4,0,0,0,.674,3.783l.052.129-.13.066a6.362,6.362,0,0,0-3.171,3.067,3.088,3.088,0,0,0,.026,2.242,4.831,4.831,0,0,0,.534,1.054c.222.333.5.631.754.952l.085.108-.077.109a3.848,3.848,0,0,0-.36,3.386,8.024,8.024,0,0,0,2.1,3.092l.053.051v.075c.011,11.444.023,24.375.036,38.354,0,6.991.007,14.243.011,21.7q0,5.594,0,11.337,0,2.869,0,5.771a7.231,7.231,0,0,0,.082,1.406,4.847,4.847,0,0,0,.465,1.3,4.5,4.5,0,0,0,7.222.953,4.448,4.448,0,0,0,1.2-2.5c.09-.951.132-1.955.2-2.924q.379-5.864.748-11.581c.52-7.616,1.024-15.018,1.51-22.152,1.022-14.263,2.01-27.446,3.089-39.094.544-5.823,1.063-11.266,1.84-16.248.224-1.241.507-2.466.83-3.6a32.014,32.014,0,0,0,.634-3.445,64.452,64.452,0,0,0,.505-6.477c.138-4.093,0-7.7-.181-10.752a54.735,54.735,0,0,0-.85-7.412v0h0c-.34-1.715-.946-3.029-1.771-3.317a1.168,1.168,0,0,0-.9.092C185.055,257.649,184.959,257.693,184.959,257.693Z",
    transform: "translate(-166.932 -257.363)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6689",
    "data-name": "Group 6689",
    transform: "translate(15.384 76.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M185.483,348.251l23.861,3.16-.815,6.992-23.394-1.611Z",
    transform: "translate(-185.135 -348.251)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6690",
    "data-name": "Group 6690",
    transform: "translate(12.808 106.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M205.964,383.422l-23.794.419-.084,9.412,23.176-2.852Z",
    transform: "translate(-182.086 -383.422)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6691",
    "data-name": "Group 6691",
    transform: "translate(13.005 29.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M210.118,314.846l-21.3-22.036-6.5,14.046.457,3.377,27.661,11.344Z",
    transform: "translate(-182.32 -292.81)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6693",
    "data-name": "Group 6693",
    transform: "translate(4.948 28.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6692",
    "data-name": "Group 6692"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M188.621,293.431a15.732,15.732,0,0,1-2.3-.519c-1.41-.347-3.369-.784-5.553-1.139s-4.182-.554-5.631-.671a15.735,15.735,0,0,1-2.348-.234,10.5,10.5,0,0,1,2.365-.077,44.317,44.317,0,0,1,11.249,1.821A10.432,10.432,0,0,1,188.621,293.431Z",
    transform: "translate(-172.787 -290.779)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6695",
    "data-name": "Group 6695",
    transform: "translate(3.35 34.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6694",
    "data-name": "Group 6694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M187.928,301.076a16.578,16.578,0,0,1-2.495-.428c-1.531-.3-3.648-.706-6-1.081s-4.487-.648-6.036-.837a16.615,16.615,0,0,1-2.5-.368,12.854,12.854,0,0,1,2.534.058c1.562.11,3.715.336,6.076.712s4.477.831,5.994,1.212A12.849,12.849,0,0,1,187.928,301.076Z",
    transform: "translate(-170.896 -298.325)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6697",
    "data-name": "Group 6697",
    transform: "translate(1.955 42.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6696",
    "data-name": "Group 6696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M186.059,308.581a16.02,16.02,0,0,1-2.464-.226c-1.515-.176-3.609-.4-5.928-.564s-4.425-.234-5.95-.272a16.041,16.041,0,0,1-2.472-.121,12.172,12.172,0,0,1,2.472-.19c1.531-.042,3.648-.019,5.981.144s4.431.439,5.94.695A12.142,12.142,0,0,1,186.059,308.581Z",
    transform: "translate(-169.245 -307.189)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6699",
    "data-name": "Group 6699",
    transform: "translate(3.286 48.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6698",
    "data-name": "Group 6698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M186.343,316.231a13.593,13.593,0,0,1-2.277-.213c-1.4-.168-3.331-.381-5.471-.538s-4.084-.221-5.492-.257a13.621,13.621,0,0,1-2.283-.118,10.381,10.381,0,0,1,2.283-.194c1.413-.044,3.37-.026,5.525.129s4.093.421,5.485.668A10.409,10.409,0,0,1,186.343,316.231Z",
    transform: "translate(-170.82 -314.891)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6701",
    "data-name": "Group 6701",
    transform: "translate(12.694 30.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6700",
    "data-name": "Group 6700"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M181.959,387.986a1.031,1.031,0,0,1,0-.247c.008-.188.019-.425.031-.722.041-.666.1-1.594.167-2.773.166-2.439.4-5.913.692-10.192.63-8.63,1.5-20.5,2.451-33.613.5-6.562.971-12.813,1.4-18.5.224-2.84.378-5.552.781-8.064.362-2.513.75-4.844,1.1-6.972.7-4.254,1.2-7.706,1.468-10.1.137-1.2.23-2.128.286-2.76l.073-.719a1.007,1.007,0,0,1,.04-.243,1.015,1.015,0,0,1,.005.247l-.029.722c-.027.635-.093,1.57-.2,2.772-.214,2.4-.666,5.87-1.33,10.132-.326,2.131-.7,4.464-1.041,6.973-.386,2.5-.526,5.206-.739,8.051-.421,5.691-.882,11.941-1.367,18.5-1.006,13.107-1.917,24.972-2.578,33.6-.35,4.275-.633,7.744-.832,10.18-.106,1.177-.188,2.1-.248,2.767-.031.295-.056.532-.075.718A1.052,1.052,0,0,1,181.959,387.986Z",
    transform: "translate(-181.952 -293.077)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6703",
    "data-name": "Group 6703",
    transform: "translate(8.527 49.259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6702",
    "data-name": "Group 6702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M177.072,390.73c-.122,0-.014-16.811.238-37.541s.557-37.54.679-37.539.014,16.808-.238,37.544S177.193,390.732,177.072,390.73Z",
    transform: "translate(-177.022 -315.65)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6705",
    "data-name": "Group 6705",
    transform: "translate(5.092 49.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6704",
    "data-name": "Group 6704"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M173.034,391.427c-.122,0-.1-16.916.053-37.775s.373-37.777.494-37.776.1,16.912-.053,37.779S173.155,391.427,173.034,391.427Z",
    transform: "translate(-172.956 -315.876)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6708",
    "data-name": "Group 6708",
    transform: "translate(100.252 40.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6707",
    "data-name": "Group 6707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M326.688,305.106a4.205,4.205,0,0,1-.093.7,17.39,17.39,0,0,1-.456,1.967,27.181,27.181,0,0,1-3,6.785,22.62,22.62,0,0,1-3.167,4.056,17.952,17.952,0,0,1-4.879,3.332,30.919,30.919,0,0,1-13.161,2.72,121.108,121.108,0,0,1-13.442-.963l-10.928-1.165-7.363-.823-2-.246a4.327,4.327,0,0,1-.694-.115,4.106,4.106,0,0,1,.7.027l2.008.164,7.378.684,10.938,1.071a126.9,126.9,0,0,0,13.4.926,30.88,30.88,0,0,0,12.991-2.646,17.757,17.757,0,0,0,4.8-3.227,22.738,22.738,0,0,0,3.158-3.96,28.658,28.658,0,0,0,3.1-6.669c.264-.83.434-1.487.533-1.936A4.169,4.169,0,0,1,326.688,305.106Z",
    transform: "translate(-267.5 -305.106)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6713",
    "data-name": "Group 6713",
    transform: "translate(132.866 93.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6710",
    "data-name": "Group 6710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M313.945,154.858c-2.478,9.9-6.462,25.483-7.663,30.176a5.556,5.556,0,0,0,.342,3.833,6.1,6.1,0,0,0,4.433,3.351,5.631,5.631,0,0,0,5.115-1.6,4.766,4.766,0,0,0,1.607-2.6c.016-1.315,5.2-21.768,7.379-30.332a5.778,5.778,0,0,0-2.124-6.043h0A5.782,5.782,0,0,0,313.945,154.858Z",
    transform: "translate(-306.091 -150.473)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6712",
    "data-name": "Group 6712",
    transform: "translate(0.58 34.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6711",
    "data-name": "Group 6711"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M316.842,194.635c-.036-.012.022-.179,0-.474a1.982,1.982,0,0,0-.478-1.116c-.661-.825-2.228-1.185-3.836-1.563a7.728,7.728,0,0,0-4.172.135,12.466,12.466,0,0,0-1.575.8,2.931,2.931,0,0,1,1.462-1.084,7.252,7.252,0,0,1,4.373-.277,16.827,16.827,0,0,1,2.324.664,3.541,3.541,0,0,1,1.67,1.138,1.967,1.967,0,0,1,.4,1.309C316.98,194.494,316.863,194.645,316.842,194.635Z",
    transform: "translate(-306.777 -190.849)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6723",
    "data-name": "Group 6723",
    transform: "translate(130.387 103.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6714",
    "data-name": "Group 6714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M328.542,178.759a11.33,11.33,0,0,0-1.208-3.777,10.372,10.372,0,0,0-1.31-4.8c-1.121-1.924-6.583-6.707-12.092-7.093a4.615,4.615,0,0,0-4.922,5.06c0,.036.008.074.014.112,0,0-4.759.739-4.8,4.159l-.017,1.38s-3.128,4.053,1.419,5.135c0,0-1.058,5.645,3.195,6a58.859,58.859,0,0,0,8.017.1l1.075,1.954-.4,2.011s-.876,3.508-3.114,4.531c-3.143,1.436-4.5.922-5.656,2.727a6.246,6.246,0,0,0-.136,6.425l2.2,4.044a9.422,9.422,0,0,0,1.612,4.553l12.7-5.663a1.026,1.026,0,0,0,.279-1.689l-2.245-2.077s1.374-.575,2.5-3.324l.781-1.895a22.464,22.464,0,0,0,2.442-5.67C329.334,188.572,328.967,181.272,328.542,178.759Z",
    transform: "translate(-303.158 -163.078)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6716",
    "data-name": "Group 6716",
    transform: "translate(2.131 14.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6715",
    "data-name": "Group 6715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M325.685,188.209a13.785,13.785,0,0,0-1.663-2.956,12.319,12.319,0,0,0-6.829-4.19,20.289,20.289,0,0,0-8.156.033c-2.077.392-3.337.78-3.358.708a3.527,3.527,0,0,1,.861-.344,25.251,25.251,0,0,1,2.435-.669,19.037,19.037,0,0,1,8.317-.157,12.093,12.093,0,0,1,6.977,4.431,8.455,8.455,0,0,1,1.2,2.241A3.026,3.026,0,0,1,325.685,188.209Z",
    transform: "translate(-305.68 -180.24)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6718",
    "data-name": "Group 6718",
    transform: "translate(1.541 9.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6717",
    "data-name": "Group 6717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M326.334,178.666a25.191,25.191,0,0,0-2.628-2,17.028,17.028,0,0,0-7.517-2.336,30.2,30.2,0,0,0-7.939.59c-2.014.39-3.249.7-3.267.637a3.416,3.416,0,0,1,.842-.313c.551-.171,1.356-.4,2.361-.63a26.883,26.883,0,0,1,8.038-.723,16.176,16.176,0,0,1,7.65,2.513,11.166,11.166,0,0,1,1.894,1.566A2.991,2.991,0,0,1,326.334,178.666Z",
    transform: "translate(-304.982 -173.826)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6720",
    "data-name": "Group 6720",
    transform: "translate(5.382 4.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6719",
    "data-name": "Group 6719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M325,171.536c-.04.063-.813-.4-2.134-.989a21.783,21.783,0,0,0-11-1.782c-1.438.139-2.319.336-2.337.265-.008-.03.206-.106.6-.22a12.923,12.923,0,0,1,1.7-.354A18.928,18.928,0,0,1,323,170.266a12.758,12.758,0,0,1,1.5.873C324.836,171.371,325.015,171.511,325,171.536Z",
    transform: "translate(-309.527 -168.263)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6722",
    "data-name": "Group 6722",
    transform: "translate(9.927 38.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6721",
    "data-name": "Group 6721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M314.9,212.065c-.027-.124,2.232-.71,4.974-1.564s4.938-1.647,4.986-1.53a32.459,32.459,0,0,1-9.961,3.094Z",
    transform: "translate(-314.904 -208.959)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6729",
    "data-name": "Group 6729",
    transform: "translate(137.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6724",
    "data-name": "Group 6724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M313.074,122.973c4.757,2.685,15.137,8.705,15.137,8.705,1.032-.481,20.115-66.177,23.7-78.544a4.147,4.147,0,0,0-.706-3.7c-2.5-3.219-8.034-9.814-10.937-9.16-3.418.77-24.284,65.232-28.676,78.912A3.216,3.216,0,0,0,313.074,122.973Z",
    transform: "translate(-311.437 -40.227)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6726",
    "data-name": "Group 6726",
    transform: "translate(0.435 79.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6725",
    "data-name": "Group 6725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M329.9,141.648c-.045.057-.92-.6-2.4-1.553a36.149,36.149,0,0,0-6.1-3.139,34.567,34.567,0,0,0-6.612-1.837c-1.737-.3-2.829-.393-2.824-.466a2.593,2.593,0,0,1,.773-.022,21,21,0,0,1,2.1.18,28.888,28.888,0,0,1,6.725,1.735,29.872,29.872,0,0,1,6.116,3.29c.727.513,1.3.952,1.672,1.277S329.915,141.624,329.9,141.648Z",
    transform: "translate(-311.952 -134.623)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6728",
    "data-name": "Group 6728",
    transform: "translate(3.78 0.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6727",
    "data-name": "Group 6727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M343.093,41.377a.769.769,0,0,1-.061.209l-.221.6q-.323.832-.887,2.282l-3.274,8.385c-2.742,7.089-6.412,16.928-10.168,27.9s-6.878,21-9.054,28.285c-1.067,3.619-1.935,6.56-2.548,8.634-.294.992-.527,1.776-.7,2.346l-.192.608a.841.841,0,0,1-.079.2.792.792,0,0,1,.036-.215c.04-.165.089-.368.15-.619l.617-2.369c.541-2.056,1.363-5.021,2.414-8.675,2.1-7.309,5.181-17.356,8.936-28.339s7.478-20.807,10.294-27.869c1.407-3.533,2.573-6.38,3.406-8.337l.963-2.251.261-.581A.792.792,0,0,1,343.093,41.377Z",
    transform: "translate(-315.91 -41.377)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6739",
    "data-name": "Group 6739",
    transform: "translate(117.701 83.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6730",
    "data-name": "Group 6730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M288.146,168.7l4.768-3.876a47.611,47.611,0,0,1,2.3-7.59,11.948,11.948,0,0,1,5.493-9.092,8.754,8.754,0,0,1,5.4-4.753,7.082,7.082,0,0,1,6.48-4.446c8.368-.36,15.044,5.061,16.115,7.592s-1.47,4.388-1.47,4.388l.538,3.079a4.933,4.933,0,0,1-.777,3.62h0s.579,4.163-2.1,4.288-3.037-1.768-3.037-1.768-2.3,1.073-3.4.745-2.665-.819-2.665-.819l-4.559-.37-3.429,2.37s-1.73,7.847-3.175,10.19-9.707,8.8-9.707,8.8Z",
    transform: "translate(-288.146 -138.926)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6732",
    "data-name": "Group 6732",
    transform: "translate(11.471 12.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6731",
    "data-name": "Group 6731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M301.719,155.059a4.758,4.758,0,0,1,1-.328,24.186,24.186,0,0,1,2.813-.547,26.9,26.9,0,0,1,9.42.489,26.344,26.344,0,0,1,4.94,1.671,11.566,11.566,0,0,1,3.633,2.253,2.975,2.975,0,0,1,.761,1.5,2.434,2.434,0,0,1-.106,1.263,1.624,1.624,0,0,1-.442.664c-.137.121-.227.159-.233.15a2.5,2.5,0,0,0,.513-.869,2.566,2.566,0,0,0-.721-2.495,11.886,11.886,0,0,0-3.57-2.093,27.889,27.889,0,0,0-4.875-1.613,29.1,29.1,0,0,0-9.284-.608C303.18,154.737,301.738,155.139,301.719,155.059Z",
    transform: "translate(-301.719 -153.976)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6734",
    "data-name": "Group 6734",
    transform: "translate(18.906 7.593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6733",
    "data-name": "Group 6733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M310.517,148.383a3.7,3.7,0,0,1,.954-.242,15.288,15.288,0,0,1,2.674-.229,17.332,17.332,0,0,1,14.865,8.315,15.356,15.356,0,0,1,1.2,2.4,3.744,3.744,0,0,1,.293.939c-.079.034-.532-1.3-1.76-3.171a17.951,17.951,0,0,0-14.607-8.171C311.9,148.156,310.53,148.468,310.517,148.383Z",
    transform: "translate(-310.517 -147.911)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6736",
    "data-name": "Group 6736",
    transform: "translate(22.029 3.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6735",
    "data-name": "Group 6735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M314.212,143.738a2.645,2.645,0,0,1,.764-.129,6.422,6.422,0,0,1,.909-.04,8.97,8.97,0,0,1,1.2.048,18.575,18.575,0,0,1,3.091.531,25.228,25.228,0,0,1,3.62,1.279,24.387,24.387,0,0,1,3.356,1.869,17.41,17.41,0,0,1,2.428,1.988,8.5,8.5,0,0,1,.817.887,6.047,6.047,0,0,1,.553.723,2.614,2.614,0,0,1,.388.671c-.069.049-.671-.876-1.972-2.054a19.711,19.711,0,0,0-2.438-1.876,27.161,27.161,0,0,0-3.312-1.806,28.207,28.207,0,0,0-3.544-1.29,21.7,21.7,0,0,0-3.018-.613C315.314,143.7,314.219,143.821,314.212,143.738Z",
    transform: "translate(-314.212 -143.566)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6738",
    "data-name": "Group 6738",
    transform: "translate(13.515 20.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6737",
    "data-name": "Group 6737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M312.234,163.286c.008.127-1.854.327-4.051,1.02a22.472,22.472,0,0,1-4.045,1.132,18.409,18.409,0,0,1,3.918-1.554A10.008,10.008,0,0,1,312.234,163.286Z",
    transform: "translate(-304.138 -163.229)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6741",
    "data-name": "Group 6741",
    transform: "translate(130.228 103.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6740",
    "data-name": "Group 6740",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M308.791,184.9a2.717,2.717,0,0,1-.527-.052,3.259,3.259,0,0,1-1.414-.6c-1.159-.822-1.76-2.956-1.391-5.381l.106.162-.722-.216a7.8,7.8,0,0,1-.718-.342,2.444,2.444,0,0,1-1.058-1.329,3.063,3.063,0,0,1,.1-1.809,6.265,6.265,0,0,1,.872-1.685l-.037.108a17.729,17.729,0,0,1,.066-1.965,3.728,3.728,0,0,1,.963-1.885,7.608,7.608,0,0,1,3.919-2l-.17.231a4.8,4.8,0,0,1,.408-2.5,4.929,4.929,0,0,1,1.745-2.021,4.833,4.833,0,0,1,2.638-.789,11.445,11.445,0,0,1,1.389.127c.452.1.917.166,1.363.309a20.314,20.314,0,0,1,7.837,4.494,14.292,14.292,0,0,1,1.488,1.541,6.853,6.853,0,0,1,1.054,1.811,10.672,10.672,0,0,1,.8,3.835l-.028-.1a16.254,16.254,0,0,1,1.5,6.509c.142,1.977.192,3.7.2,5.122s-.043,2.538-.12,3.3c-.045.379-.077.668-.123.861a1.1,1.1,0,0,1-.074.29c-.024-.005.041-.4.081-1.16s.053-1.869.016-3.284-.117-3.135-.285-5.1a16.225,16.225,0,0,0-1.511-6.335l-.027-.051,0-.051a10.367,10.367,0,0,0-.793-3.675,8.538,8.538,0,0,0-2.453-3.194,20.047,20.047,0,0,0-7.67-4.384c-.433-.139-.881-.2-1.317-.3a10.95,10.95,0,0,0-1.317-.123,4.4,4.4,0,0,0-2.4.713,4.511,4.511,0,0,0-1.6,1.837,4.4,4.4,0,0,0-.381,2.268l.023.19-.193.041a7.25,7.25,0,0,0-3.7,1.862,3.342,3.342,0,0,0-.877,1.681,18.265,18.265,0,0,0-.078,1.9l0,.059-.035.05a4.067,4.067,0,0,0-.942,3.183,2.133,2.133,0,0,0,.908,1.163c.219.117.437.233.66.325l.683.216.126.04-.02.123c-.391,2.346.146,4.407,1.209,5.211a3.424,3.424,0,0,0,1.335.638A2.683,2.683,0,0,1,308.791,184.9Z",
    transform: "translate(-302.969 -162.825)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6943",
    "data-name": "Group 6943",
    transform: "translate(36.82 48.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6742",
    "data-name": "Group 6742",
    transform: "translate(5.284 0.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M244.146,129.646a26.574,26.574,0,0,0-.288-8.743c-.11-.463-1.9-10.1-8.415-16.527-4.644-4.586-12.449-6.914-18.718-5.43s-13.519,5.333-16.236,12.558-1.541,10.739-1.541,10.739-.427,6.165.026,7.785c.767,2.741,5.019,8.664,5.019,8.664l2.4,2.318,33.948-5.863Z",
    transform: "translate(-198.695 -98.501)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6917",
    "data-name": "Group 6917",
    transform: "translate(7.31 2.133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6751",
    "data-name": "Group 6751",
    transform: "translate(32.302 4.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6750",
    "data-name": "Group 6750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6749",
    "data-name": "Group 6749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6748",
    "data-name": "Group 6748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6747",
    "data-name": "Group 6747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6746",
    "data-name": "Group 6746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6745",
    "data-name": "Group 6745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6744",
    "data-name": "Group 6744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6743",
    "data-name": "Group 6743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M248.594,135.663a79,79,0,0,0-.3-13.623,27.591,27.591,0,0,0-4.718-12.652c-.407-.556-3.562-4.167-4.2-3.915-.459.181,1.86,3.727,1.738,4.2a23.392,23.392,0,0,0,1.195,13.84,61.635,61.635,0,0,0,6.287,12.146",
    transform: "translate(-239.314 -105.46)",
    fill: "#fff"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6753",
    "data-name": "Group 6753",
    transform: "translate(0 1.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6752",
    "data-name": "Group 6752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M201.728,127.362a20.392,20.392,0,0,1,13.148-24.33l1-.342c10.987-3.064,19.728,4.555,22.488,15.623l9.415,35.273-2.4,19.582-20.8-8.324c-.91-3.08-1.193-4.006-1.217-4,0,0-10.907,1.94-14.586-8.369C207,147.5,204.173,136.942,201.728,127.362Z",
    transform: "translate(-201.091 -102.008)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6764",
    "data-name": "Group 6764",
    transform: "translate(22.268 51.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6763",
    "data-name": "Group 6763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6762",
    "data-name": "Group 6762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6761",
    "data-name": "Group 6761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6760",
    "data-name": "Group 6760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6759",
    "data-name": "Group 6759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6758",
    "data-name": "Group 6758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6757",
    "data-name": "Group 6757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6756",
    "data-name": "Group 6756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6755",
    "data-name": "Group 6755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6754",
    "data-name": "Group 6754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M227.441,170.05a26.437,26.437,0,0,0,12.114-8.608s-.574,8.9-11.225,11.506Z",
    transform: "translate(-227.441 -161.442)",
    fill: "#fff"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6781",
    "data-name": "Group 6781",
    transform: "translate(6.197 33.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6780",
    "data-name": "Group 6780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6779",
    "data-name": "Group 6779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6778",
    "data-name": "Group 6778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6777",
    "data-name": "Group 6777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6776",
    "data-name": "Group 6776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6775",
    "data-name": "Group 6775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6774",
    "data-name": "Group 6774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6773",
    "data-name": "Group 6773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6772",
    "data-name": "Group 6772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6771",
    "data-name": "Group 6771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6770",
    "data-name": "Group 6770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6769",
    "data-name": "Group 6769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6768",
    "data-name": "Group 6768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6767",
    "data-name": "Group 6767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6766",
    "data-name": "Group 6766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6765",
    "data-name": "Group 6765"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M208.487,141.548a1.563,1.563,0,0,0,1.937,1,1.5,1.5,0,0,0,1.067-1.856,1.563,1.563,0,0,0-1.935-1A1.5,1.5,0,0,0,208.487,141.548Z",
    transform: "translate(-208.425 -139.628)",
    fill: "#fff"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6799",
    "data-name": "Group 6799",
    transform: "translate(4.347 28.013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6798",
    "data-name": "Group 6798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6797",
    "data-name": "Group 6797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6796",
    "data-name": "Group 6796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6795",
    "data-name": "Group 6795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6794",
    "data-name": "Group 6794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6793",
    "data-name": "Group 6793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6792",
    "data-name": "Group 6792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6791",
    "data-name": "Group 6791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6790",
    "data-name": "Group 6790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6789",
    "data-name": "Group 6789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6788",
    "data-name": "Group 6788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6787",
    "data-name": "Group 6787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6786",
    "data-name": "Group 6786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6785",
    "data-name": "Group 6785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6784",
    "data-name": "Group 6784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6783",
    "data-name": "Group 6783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6782",
    "data-name": "Group 6782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M206.294,136.016c.249.13,1.085-1.083,2.678-1.624,1.583-.564,3.031-.146,3.137-.4.055-.115-.251-.4-.887-.6a4.29,4.29,0,0,0-2.593.082,4.119,4.119,0,0,0-2.049,1.534C206.221,135.556,206.174,135.96,206.294,136.016Z",
    transform: "translate(-206.235 -133.234)",
    fill: "#fff"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6816",
    "data-name": "Group 6816",
    transform: "translate(20.557 29.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6815",
    "data-name": "Group 6815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6814",
    "data-name": "Group 6814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6813",
    "data-name": "Group 6813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6812",
    "data-name": "Group 6812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6811",
    "data-name": "Group 6811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6810",
    "data-name": "Group 6810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6809",
    "data-name": "Group 6809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6808",
    "data-name": "Group 6808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6807",
    "data-name": "Group 6807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6806",
    "data-name": "Group 6806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6805",
    "data-name": "Group 6805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6804",
    "data-name": "Group 6804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6803",
    "data-name": "Group 6803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6802",
    "data-name": "Group 6802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6801",
    "data-name": "Group 6801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6800",
    "data-name": "Group 6800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M225.478,136.5a1.563,1.563,0,0,0,1.937,1,1.494,1.494,0,0,0,1.067-1.856,1.563,1.563,0,0,0-1.936-1A1.5,1.5,0,0,0,225.478,136.5Z",
    transform: "translate(-225.416 -134.576)",
    fill: "#fff"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6834",
    "data-name": "Group 6834",
    transform: "translate(19.809 23.415)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6833",
    "data-name": "Group 6833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6832",
    "data-name": "Group 6832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6831",
    "data-name": "Group 6831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6830",
    "data-name": "Group 6830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6829",
    "data-name": "Group 6829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6828",
    "data-name": "Group 6828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6827",
    "data-name": "Group 6827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6826",
    "data-name": "Group 6826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6825",
    "data-name": "Group 6825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6824",
    "data-name": "Group 6824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6823",
    "data-name": "Group 6823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6822",
    "data-name": "Group 6822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6821",
    "data-name": "Group 6821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6820",
    "data-name": "Group 6820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6819",
    "data-name": "Group 6819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6818",
    "data-name": "Group 6818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6817",
    "data-name": "Group 6817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M224.589,130.575c.25.13,1.088-1.083,2.679-1.624,1.582-.564,3.031-.145,3.137-.4.054-.115-.249-.4-.887-.595a4.289,4.289,0,0,0-2.593.081,4.125,4.125,0,0,0-2.049,1.534C224.517,130.114,224.47,130.52,224.589,130.575Z",
    transform: "translate(-224.531 -127.794)",
    fill: "#fff"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6851",
    "data-name": "Group 6851",
    transform: "translate(14.058 26.492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6850",
    "data-name": "Group 6850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6849",
    "data-name": "Group 6849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6848",
    "data-name": "Group 6848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6847",
    "data-name": "Group 6847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6846",
    "data-name": "Group 6846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6845",
    "data-name": "Group 6845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6844",
    "data-name": "Group 6844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6843",
    "data-name": "Group 6843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6842",
    "data-name": "Group 6842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6841",
    "data-name": "Group 6841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6840",
    "data-name": "Group 6840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6839",
    "data-name": "Group 6839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6838",
    "data-name": "Group 6838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6837",
    "data-name": "Group 6837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6836",
    "data-name": "Group 6836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6835",
    "data-name": "Group 6835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M222.282,144.941a11.127,11.127,0,0,0-2.744.42c-.421.1-.833.149-1-.106a2.182,2.182,0,0,1-.142-1.3q.067-1.671.14-3.506c.158-4.977.124-9.012-.076-9.017s-.492,4.026-.65,9q-.043,1.837-.084,3.507a2.485,2.485,0,0,0,.336,1.667,1.077,1.077,0,0,0,.871.365,2.944,2.944,0,0,0,.723-.14A10.942,10.942,0,0,0,222.282,144.941Z",
    transform: "translate(-217.726 -131.435)",
    fill: "#fff"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6864",
    "data-name": "Group 6864",
    transform: "translate(18.753 19.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6863",
    "data-name": "Group 6863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6862",
    "data-name": "Group 6862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6861",
    "data-name": "Group 6861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6860",
    "data-name": "Group 6860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6859",
    "data-name": "Group 6859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6858",
    "data-name": "Group 6858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6857",
    "data-name": "Group 6857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6856",
    "data-name": "Group 6856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6855",
    "data-name": "Group 6855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6854",
    "data-name": "Group 6854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6853",
    "data-name": "Group 6853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6852",
    "data-name": "Group 6852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M223.345,126.339c.339.34,1.569-.532,3.239-1.116,1.656-.623,3.178-.75,3.2-1.221,0-.222-.412-.494-1.122-.628a5.3,5.3,0,0,0-2.7.261,5.1,5.1,0,0,0-2.2,1.519C223.316,125.707,223.19,126.174,223.345,126.339Z",
    transform: "translate(-223.282 -123.302)",
    fill: "#fff"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6877",
    "data-name": "Group 6877",
    transform: "translate(2.216 21.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6876",
    "data-name": "Group 6876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6875",
    "data-name": "Group 6875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6874",
    "data-name": "Group 6874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6873",
    "data-name": "Group 6873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6872",
    "data-name": "Group 6872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6871",
    "data-name": "Group 6871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6870",
    "data-name": "Group 6870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6869",
    "data-name": "Group 6869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6868",
    "data-name": "Group 6868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6867",
    "data-name": "Group 6867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6866",
    "data-name": "Group 6866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6865",
    "data-name": "Group 6865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M203.826,128.874c.451.255,1.63-.547,3.19-1.075,1.543-.575,2.971-.7,3.151-1.179.074-.228-.254-.524-.945-.679a5.3,5.3,0,0,0-2.8.254,5.219,5.219,0,0,0-2.315,1.563C203.682,128.312,203.622,128.745,203.826,128.874Z",
    transform: "translate(-203.713 -125.853)",
    fill: "#fff"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6886",
    "data-name": "Group 6886",
    transform: "translate(39.056 24.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6885",
    "data-name": "Group 6885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6884",
    "data-name": "Group 6884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6883",
    "data-name": "Group 6883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6882",
    "data-name": "Group 6882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6881",
    "data-name": "Group 6881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6880",
    "data-name": "Group 6880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6879",
    "data-name": "Group 6879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6878",
    "data-name": "Group 6878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M247.3,130.447c.15-.137,6.392-4.543,8.593,2.612s-5.437,7.889-5.513,7.688S247.3,130.447,247.3,130.447Z",
    transform: "translate(-247.305 -128.98)",
    fill: "#fff"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6896",
    "data-name": "Group 6896",
    transform: "translate(42.427 26.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6895",
    "data-name": "Group 6895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6894",
    "data-name": "Group 6894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6893",
    "data-name": "Group 6893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6892",
    "data-name": "Group 6892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6891",
    "data-name": "Group 6891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6890",
    "data-name": "Group 6890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6889",
    "data-name": "Group 6889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6888",
    "data-name": "Group 6888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6887",
    "data-name": "Group 6887"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M252.356,137.777c.025-.033.151.049.392.08a1.3,1.3,0,0,0,.937-.267,3.227,3.227,0,0,0,.576-3.206,4.311,4.311,0,0,0-.9-1.678,1.507,1.507,0,0,0-1.232-.668.664.664,0,0,0-.63.568c-.034.23.056.358.021.383-.014.024-.19-.073-.224-.386a.835.835,0,0,1,.144-.535.982.982,0,0,1,.634-.394,1.832,1.832,0,0,1,1.643.708,4.432,4.432,0,0,1,1.046,1.862c.4,1.456.074,3.032-.868,3.649a1.4,1.4,0,0,1-1.2.161C252.421,137.946,252.334,137.8,252.356,137.777Z",
    transform: "translate(-251.295 -131.646)",
    fill: "#fff"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6905",
    "data-name": "Group 6905",
    transform: "translate(1.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6904",
    "data-name": "Group 6904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6903",
    "data-name": "Group 6903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6902",
    "data-name": "Group 6902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6901",
    "data-name": "Group 6901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6900",
    "data-name": "Group 6900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6899",
    "data-name": "Group 6899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6898",
    "data-name": "Group 6898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6897",
    "data-name": "Group 6897"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M203.075,113.8c-1.352-.295,1.012-5.094,3.48-7.238,3.729-3.242,9.956-6.409,14.269-6.467,5.192-.068,9.879,1.128,13.582,4.77a29.446,29.446,0,0,1,7.461,13.465,8.945,8.945,0,0,1,.3,4.684c-.53,1.885-2.155,3.457-1.419,5.62a3.135,3.135,0,0,1-.092,2.412c-.9,1.788-2.894.955-4.024-.141-2.415-2.34-3.59-5.643-4.688-8.821a21.911,21.911,0,0,1-1.58-6.959c-.005-1.3.222-2.6.145-3.9a4.493,4.493,0,0,0-1.575-3.43,4.661,4.661,0,0,0-.759-.417,7.807,7.807,0,0,0-7.844.8c-3.615,2.633-9.878,6.823-12.089,5.99a11.543,11.543,0,0,1-4.184-2.3Z",
    transform: "translate(-202.681 -100.088)",
    fill: "#fff"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6916",
    "data-name": "Group 6916",
    transform: "translate(20.302 39.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6915",
    "data-name": "Group 6915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6914",
    "data-name": "Group 6914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6913",
    "data-name": "Group 6913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6912",
    "data-name": "Group 6912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6911",
    "data-name": "Group 6911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6910",
    "data-name": "Group 6910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6909",
    "data-name": "Group 6909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6908",
    "data-name": "Group 6908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6907",
    "data-name": "Group 6907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6906",
    "data-name": "Group 6906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M228.783,146.815c-.252.058.227,1.709-.842,3.293s-2.879,1.916-2.825,2.151c.008.11.485.205,1.234.009a4.289,4.289,0,0,0,2.386-1.7,3.732,3.732,0,0,0,.6-2.731C229.2,147.128,228.893,146.772,228.783,146.815Z",
    transform: "translate(-225.115 -146.812)",
    fill: "#fff"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6920",
    "data-name": "Group 6920",
    transform: "translate(18.25 33.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6918",
    "data-name": "Group 6918",
    transform: "translate(19.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M246.031,136.715s.9,17.089-7.513,23.16l-1.1-.349s7.714-7.575,7.228-22.37Z",
    transform: "translate(-237.418 -136.715)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6919",
    "data-name": "Group 6919",
    transform: "translate(0 21.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M214.037,167.027s7.7-6.914,21.5-3.816c0,0-2.767,5.4-10.534,7.038C219.01,171.517,214,167.139,214.037,167.027Z",
    transform: "translate(-214.037 -162.413)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6928",
    "data-name": "Group 6928",
    transform: "translate(5.121 26.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6921",
    "data-name": "Group 6921"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M216.931,166a23.782,23.782,0,0,1-8.141-1.378l-.448-.147c-2.349-.754-9.423-13.993-9.784-15.745-.41-2,1.5-10.68,1.724-11.664l.825.184c-.586,2.624-2.038,9.771-1.721,11.31.433,2.1,7.5,14.56,9.214,15.111l.456.15c2.179.723,6.236,2.069,13.469.826,7.589-1.306,14.975-8.332,16.321-10.916,1.048-2.012,3.309-17.108,4.358-24.808l.837.114c-.124.915-3.069,22.441-4.445,25.085-1.444,2.775-8.946,9.986-16.927,11.358A33.824,33.824,0,0,1,216.931,166Z",
    transform: "translate(-198.501 -128.922)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6922",
    "data-name": "Group 6922",
    transform: "translate(0.145 10.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M199.325,150.919l-.652-.538c.233-.282,5.9-6.929,22.089-8.293,16.248-1.373,20.366,3.978,20.533,4.207l-.681.5c-.039-.052-4.082-5.187-19.781-3.866C205.033,144.261,199.38,150.853,199.325,150.919Z",
    transform: "translate(-198.673 -141.863)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6923",
    "data-name": "Group 6923",
    transform: "translate(4.627 22.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M204.4,161.649l-.42-.733a52.056,52.056,0,0,1,17.943-5.522,30.481,30.481,0,0,1,17.685,2.928l-.423.732a30.245,30.245,0,0,0-17.164-2.82A51.185,51.185,0,0,0,204.4,161.649Z",
    transform: "translate(-203.976 -155.164)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6924",
    "data-name": "Group 6924",
    transform: "translate(23.268 11.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M230.708,165.735c-.145-.419-3.533-10.288-3.816-11.213-.291-.952-.8-10.705-.859-11.815l.844-.044c.222,4.314.626,10.967.823,11.612.278.912,3.771,11.083,3.806,11.185Z",
    transform: "translate(-226.033 -142.663)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6925",
    "data-name": "Group 6925",
    transform: "translate(10.478 13.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M220.8,168.2s-5.976-10.544-6.769-11.952c-.813-1.441-3.032-10.547-3.127-10.934l.821-.2c.633,2.6,2.414,9.606,3.042,10.719.794,1.407,6.769,11.95,6.769,11.95Z",
    transform: "translate(-210.9 -145.115)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6926",
    "data-name": "Group 6926",
    transform: "translate(2.626 17.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M212.632,168.6c-.212-.312-5.209-7.672-6.272-9.393-.4-.648-4.575-8.987-4.752-9.342l.756-.378c1.5,2.993,4.409,8.782,4.715,9.275,1.054,1.705,6.2,9.286,6.252,9.363Z",
    transform: "translate(-201.608 -149.492)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6927",
    "data-name": "Group 6927",
    transform: "translate(34.351 7.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M239.989,161.3l-.841-.079a67.007,67.007,0,0,1,1.006-7.063c.515-2.017,1.265-10.727,1.272-10.815.124-1.5.417-5.012.467-5.231l.825.182-.412-.09.415.081c-.04.231-.3,3.269-.451,5.13-.031.362-.763,8.869-1.3,10.953A68.168,68.168,0,0,0,239.989,161.3Z",
    transform: "translate(-239.148 -138.114)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6942",
    "data-name": "Group 6942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6929",
    "data-name": "Group 6929",
    transform: "translate(6.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M217.275,97.567l7.7.456a1.994,1.994,0,0,1,.728.183c1.72.8,8.309,1.583,10.88,5.885,1.828,3.058,4.71,7.554,5.867,11.158a2.022,2.022,0,0,1-2.568,2.551,18.1,18.1,0,0,0-7.557-1.083c-9.913.937-23.461,3.091-29.339,4.369-1.389.3-2.791-.194-2.574-1.6.483-3.133,1.251-7.865,1.7-9.4.609-2.081,4.895-6.668,5.921-7.745a1.982,1.982,0,0,1,.5-.38l7.656-4.151A2.03,2.03,0,0,1,217.275,97.567Z",
    transform: "translate(-200.393 -97.564)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6930",
    "data-name": "Group 6930",
    transform: "translate(0 15.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M203.724,117.23c4.089-1.164,13.634-1.969,18.4-1.293a26.058,26.058,0,0,1,9.057,3.422l-32.259,5.557-6.48,1.505C195,122.308,199.636,118.394,203.724,117.23Z",
    transform: "translate(-192.442 -115.69)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6932",
    "data-name": "Group 6932",
    transform: "translate(5.45 14.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6931",
    "data-name": "Group 6931"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M198.891,120.257a8.129,8.129,0,0,1,1.172-.711c.77-.43,1.909-1.009,3.354-1.65a35.19,35.19,0,0,1,5.252-1.8,28.361,28.361,0,0,1,6.754-.818,40.449,40.449,0,0,1,12.218,1.547,18.708,18.708,0,0,1,3.448,1.464c.386.216.676.4.867.533s.287.21.279.222c-.019.03-.438-.22-1.225-.6a21.986,21.986,0,0,0-3.459-1.318,43.464,43.464,0,0,0-12.123-1.4,29.158,29.158,0,0,0-6.663.772,38.309,38.309,0,0,0-5.228,1.7c-1.449.6-2.6,1.133-3.4,1.515A8.311,8.311,0,0,1,198.891,120.257Z",
    transform: "translate(-198.891 -115.267)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6933",
    "data-name": "Group 6933",
    transform: "translate(39.692 17.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M249.072,122.595l.43,4.672-3.643,1.616s.041,5.271-1.953,6.017a4.335,4.335,0,0,1-3.875-.794l-.623-14.566s6.48-1.855,6.446-1.6S249.072,122.595,249.072,122.595Z",
    transform: "translate(-239.408 -117.918)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6935",
    "data-name": "Group 6935",
    transform: "translate(19.144 1.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6934",
    "data-name": "Group 6934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M215.126,109.648a20.141,20.141,0,0,1,.824-5.561,20.119,20.119,0,0,1,1.934-5.279c.121.048-.753,2.4-1.508,5.388S215.255,109.663,215.126,109.648Z",
    transform: "translate(-215.094 -98.807)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6937",
    "data-name": "Group 6937",
    transform: "translate(6.568 4.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6936",
    "data-name": "Group 6936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M200.218,114.853a9.116,9.116,0,0,1,.941-1.835c.636-1.1,1.558-2.6,2.633-4.212s2.1-3.041,2.874-4.051A9.129,9.129,0,0,1,208,103.181a10.14,10.14,0,0,1-1.078,1.755l-2.762,4.115-2.735,4.132A10.093,10.093,0,0,1,200.218,114.853Z",
    transform: "translate(-200.213 -103.179)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6939",
    "data-name": "Group 6939",
    transform: "translate(32.156 0.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6938",
    "data-name": "Group 6938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M237.17,107.694c-.123.057-1.195-2.3-3.047-4.876-1.836-2.587-3.722-4.363-3.628-4.462a5.519,5.519,0,0,1,1.315,1.083,23.683,23.683,0,0,1,4.762,6.661A5.473,5.473,0,0,1,237.17,107.694Z",
    transform: "translate(-230.491 -98.353)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6941",
    "data-name": "Group 6941",
    transform: "translate(39.468 19.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6940",
    "data-name": "Group 6940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M250.584,127.434a17.08,17.08,0,0,0-11.44-7.2,6.549,6.549,0,0,1,2.055.2,13.715,13.715,0,0,1,8.313,5.23A6.56,6.56,0,0,1,250.584,127.434Z",
    transform: "translate(-239.143 -120.211)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Lines",
    transform: "translate(96.201 175.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6949",
    "data-name": "Group 6949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6946",
    "data-name": "Group 6946",
    transform: "translate(2.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6945",
    "data-name": "Group 6945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M287.89,218.793s-.152.087-.458.237l-1.364.655-5.268,2.474a204.3,204.3,0,0,1-20.027,7.535,227.173,227.173,0,0,1-30.852,7.407l-2.222.389-2.259.32-4.6.642c-3.1.42-6.285.685-9.517,1.045-6.484.491-13.211.91-20.109.881a219.467,219.467,0,0,1-38.725-3.132,92.056,92.056,0,0,1-16.383-4.428,47.31,47.31,0,0,1-12.907-7.176,31.118,31.118,0,0,1-4.48-4.66,24.964,24.964,0,0,1-2.888-4.99,16.657,16.657,0,0,1-1.178-9.062,15.058,15.058,0,0,1,2.142-5.394l.922-1.2c.21-.27.325-.4.325-.4s-.093.15-.29.428l-.883,1.224a15.324,15.324,0,0,0-2.047,5.374,16.562,16.562,0,0,0,1.236,8.939,24.748,24.748,0,0,0,2.884,4.916,30.914,30.914,0,0,0,4.455,4.59,47.207,47.207,0,0,0,12.84,7.075,92.226,92.226,0,0,0,16.324,4.369,221.408,221.408,0,0,0,38.65,3.091c6.886.029,13.6-.386,20.074-.87,3.226-.357,6.406-.618,9.5-1.034l4.59-.634,2.256-.316,2.218-.384a230.968,230.968,0,0,0,30.825-7.3c8.64-2.633,15.381-5.487,20.053-7.395l5.3-2.4,1.383-.615C287.725,218.853,287.89,218.793,287.89,218.793Z",
    transform: "translate(-114.457 -199.933)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6948",
    "data-name": "Group 6948",
    transform: "translate(0 32.392)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6947",
    "data-name": "Group 6947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M165.646,250.958a2.826,2.826,0,0,1-.574.019l-1.645-.03c-1.429-.024-3.5-.135-6.043-.33a139.15,139.15,0,0,1-19.733-3.025c-3.8-.876-7.389-1.87-10.615-2.883-3.213-1.052-6.088-2.06-8.452-3.037-1.192-.461-2.251-.925-3.182-1.334s-1.729-.761-2.371-1.077l-1.48-.72a2.737,2.737,0,0,1-.5-.278,2.854,2.854,0,0,1,.541.2l1.512.644c.652.292,1.456.63,2.4,1.007s2,.829,3.2,1.271c2.372.937,5.25,1.912,8.46,2.939,3.223.99,6.8,1.968,10.592,2.842a154.572,154.572,0,0,0,19.662,3.143c2.54.234,4.6.393,6.024.47l1.64.112A2.792,2.792,0,0,1,165.646,250.958Z",
    transform: "translate(-111.048 -238.262)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetUsers);
export default __webpack_public_path__ + "static/media/Target_Users.aaaef2c38fea722fb1b7404706e6bca5.svg";
export { ForwardRef as ReactComponent };